import { useState, useEffect, useCallback, useMemo, Fragment } from "react";

// ─── PASSWORD ────────────────────────────────────────────────────────────────
// ⚠ SECURITY NOTE: this password and the API key below ship to every visitor's
// browser and are readable in dev tools. Treat this login as a courtesy screen,
// not security. Restrict the API key to your domain in Google Cloud Console,
// and move to real auth (backend) before sharing this URL widely.
const APP_PASSWORD = "Temiyah10!";

// ─── PAYMENT LOGGING BRIDGE ─────────────────────────────────────────────────
// Points at the Apps Script Web App deployment (see WebApp.gs). The key here
// is a courtesy lock, same caveat as APP_PASSWORD above — it's visible in
// dev tools, and it's paired with "Execute as: Me" on the Apps Script side
// to keep casual/bot traffic from writing rows.
const DASHBOARD_ENDPOINT = "https://script.google.com/macros/s/AKfycbw4eBO6Q8nvR5yc0tFAqVYbbRJuRL-Oys8TYQdKiDDXrgvXeLrG2c6jc5pWIUiqG3A/exec";
const DASHBOARD_KEY = "rtyuiouiyutyrte7654344567youytr434ers1234";


const LoginScreen = ({ onLogin }) => {
  const [input, setInput]   = useState("");
  const [error, setError]   = useState(false);
  const [shake, setShake]   = useState(false);

  const attempt = () => {
    if (input === APP_PASSWORD) {
      sessionStorage.setItem("fe_auth", "1");
      onLogin();
    } else {
      setError(true);
      setShake(true);
      setInput("");
      setTimeout(() => setShake(false), 500);
    }
  };

  return (
    <div style={{ minHeight:"100vh", background:"#f5f4f2", display:"flex", alignItems:"center", justifyContent:"center", fontFamily:"'DM Sans','Segoe UI',sans-serif" }}>
      <link href="https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@700;900&family=DM+Sans:wght@400;600;700;800&display=swap" rel="stylesheet" />
      <style>{`@keyframes shake{0%,100%{transform:translateX(0)}20%,60%{transform:translateX(-8px)}40%,80%{transform:translateX(8px)}}`}</style>
      <div style={{ background:"#fff", border:"1px solid #e8e4de", borderRadius:16, padding:"48px 40px", width:"100%", maxWidth:380, boxShadow:"0 8px 40px #0000000f", animation: shake ? "shake 0.4s ease" : "none" }}>
        <div style={{ textAlign:"center", marginBottom:32 }}>
          <div style={{ background:"linear-gradient(135deg,#f4600c,#d44e08)", borderRadius:12, width:52, height:52, display:"flex", alignItems:"center", justifyContent:"center", fontSize:24, color:"#fff", fontWeight:900, fontFamily:"'Barlow Condensed',sans-serif", margin:"0 auto 16px" }}>F</div>
          <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900, fontSize:26, color:"#1a1612", letterSpacing:"0.01em" }}>FLEX<span style={{ color:"#f4600c" }}>EARN</span> FLEET</div>
          <div style={{ fontSize:12, color:"#a09486", letterSpacing:"0.1em", textTransform:"uppercase", fontWeight:700, marginTop:4 }}>Operations Dashboard</div>
        </div>

        <div style={{ marginBottom:16 }}>
          <div style={{ fontSize:12, fontWeight:700, color:"#6b6056", textTransform:"uppercase", letterSpacing:"0.1em", marginBottom:8 }}>Password</div>
          <input
            type="password"
            value={input}
            onChange={e => { setInput(e.target.value); setError(false); }}
            onKeyDown={e => e.key === "Enter" && attempt()}
            placeholder="Enter password"
            style={{ width:"100%", padding:"12px 14px", border:`1.5px solid ${error ? "#c0392b" : "#e8e4de"}`, borderRadius:8, fontSize:15, fontFamily:"inherit", outline:"none", boxSizing:"border-box", background: error ? "#fdf0ee" : "#fff", transition:"border-color 0.2s" }}
            autoFocus
          />
          {error && <div style={{ fontSize:12, color:"#c0392b", marginTop:6, fontWeight:600 }}>Incorrect password. Try again.</div>}
        </div>

        <button onClick={attempt} style={{ width:"100%", background:"linear-gradient(135deg,#f4600c,#d44e08)", color:"#fff", border:"none", borderRadius:8, padding:"13px", fontSize:15, fontWeight:800, cursor:"pointer", fontFamily:"inherit", letterSpacing:"0.02em" }}>
          Access Dashboard
        </button>

        <div style={{ textAlign:"center", marginTop:20, fontSize:11, color:"#a09486" }}>
          flexearnfleet.com
        </div>

        <div style={{ marginTop:20, padding:"14px 16px", background:"#faf9f7", border:"1px solid #e8e4de", borderRadius:8 }}>
          <div style={{ fontSize:11, fontWeight:800, color:"#6b6056", textTransform:"uppercase", letterSpacing:"0.1em", marginBottom:6 }}>⚠ Restricted Access</div>
          <div style={{ fontSize:11, color:"#a09486", lineHeight:1.6 }}>
            This system is the exclusive property of <strong style={{ color:"#6b6056" }}>JRPZ Enterprise LLC</strong> and is restricted to authorized users only. Unauthorized access, use, or disclosure of any information contained herein is strictly prohibited and may be subject to civil and criminal penalties under applicable law. By entering your credentials you confirm you are an authorized user and agree to use this system solely for its intended business purpose. All activity on this platform may be monitored and recorded.
          </div>
        </div>
      </div>
    </div>
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// 🔧 CONFIGURATION — REPLACE WITH YOUR VALUES BEFORE DEPLOYING
// ─────────────────────────────────────────────────────────────────────────────
const SHEET_ID  = "1ET-t3l9Jk34kaD0q44e3i5mdiLucduvwqRHMpxCf7lY";   // From your Google Sheet URL
const API_KEY   = "AIzaSyC84iCGUOo9wspK-9MnWBzDPDK096iHAck";     // From Google Cloud Console

// Sheet tab names — must match exactly what's in your spreadsheet
const TABS = {
  cars:     "🚗 Cars",
  drivers:  "👤 Drivers",
  repairs:  "🔧 Repairs",
  payments: "💰 Payments",
  expenses: "💸 Expenses",
};

// Insurance policy: FlexEarn covers each active vehicle's insurance up to this
// amount per month. Drivers pay the insurer directly and pay FlexEarn the
// remainder — the covered portion is logged as "Insurance Credit ($)" on the
// payment row, and any insurance FlexEarn pays directly is logged in the
// 💸 Expenses tab under "Insurance Actual". Both count as real expenses here.
const INSURANCE_CAP_MONTHLY = 300;
// ─────────────────────────────────────────────────────────────────────────────

// ─── THEME ───────────────────────────────────────────────────────────────────
const DARK_STR = '#1A1612';
// Parses sheet date strings (e.g. "6/1/2026") into real Date objects for
// chronological sorting — comparing them as text breaks whenever a
// single-digit month/day is compared against a double-digit one.
function toDate(s) {
  if (!s) return new Date(0);
  const d = new Date(s);
  return isNaN(d.getTime()) ? new Date(0) : d;
}

// ─── RESPONSIVE ─────────────────────────────────────────────────────────────
// Below this width we're on a phone-sized screen: force the card layouts
// (tables still work via horizontal scroll if someone taps into "Table" view
// manually, but cards are the default because they read cleanly without
// side-scrolling).
const MOBILE_BREAKPOINT = 720;
function useIsMobile() {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < MOBILE_BREAKPOINT : false
  );
  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);
  return isMobile;
}

const T = {
  bg: "#f5f4f2", surface: "#ffffff", surface2: "#faf9f7",
  border: "#e8e4de", border2: "#d8d2ca",
  orange: "#f4600c", orangeD: "#d44e08", orangeL: "#fff2ec",
  text: "#1a1612", textMid: "#6b6056", textSub: "#a09486",
  green: "#1a7a4a", greenBg: "#edf7f1",
  red: "#c0392b", redBg: "#fdf0ee",
  blue: "#1e5fa8", blueBg: "#eef4fd",
  gold: "#a07820", goldBg: "#fdf6e3",
  purple: "#6b3fa0", purpleBg: "#f5f0fb",
};

// ─── GOOGLE SHEETS FETCHER ───────────────────────────────────────────────────
async function fetchSheet(tabName) {
  const encoded = encodeURIComponent(tabName);
  const url = `https://sheets.googleapis.com/v4/spreadsheets/${SHEET_ID}/values/${encoded}?key=${API_KEY}`;
  const res = await fetch(url);
  if (!res.ok) throw new Error(`Failed to fetch ${tabName}: ${res.status}`);
  const data = await res.json();
  const rows = data.values || [];
  // Row 0 = title, Row 1 = subtitle, Row 2 = headers, Row 3+ = data
  const headers = rows[2] || [];
  return rows.slice(3).map(row => {
    const obj = {};
    headers.forEach((h, i) => { obj[h.trim()] = (row[i] || "").trim(); });
    return obj;
  }).filter(row => Object.values(row).some(v => v !== ""));
}

// ─── DATA NORMALIZERS ────────────────────────────────────────────────────────
const num = (v) => parseFloat(String(v ?? "0").replace(/[$,%\s]/g, "")) || 0;
const int = (v) => parseInt(String(v ?? "0").replace(/[^0-9-]/g, "")) || 0;

function normalizeCars(rows) {
  return rows.map(r => ({
    id:             r["Car ID"]             || "",
    year:           r["Year"]               || "",
    make:           r["Make"]               || "",
    model:          r["Model"]              || "",
    city:           r["City"]               || "",
    purchasePrice:  num(r["Purchase Price ($)"]),
    totalStartup:   num(r["TOTAL STARTUP ($)"]) || num(r["Purchase Price ($)"]),
    mileage:        int(r["Current Mileage"]),
    status:         r["Status"]             || "Active",
    condition:      r["Condition"]          || "Good",
    driver:         r["Assigned Driver ID"] || null,
    ownership:      (r["Ownership Track"]   || "").toLowerCase() === "yes",
    lastService:    r["Last Service Date"]  || "",
    notes:          r["Notes"]              || "",
    vin:            r["VIN"]                || "",
    licensePlate:   r["License Plate"]      || "",
    regExpiration:  r["Registration Expiration"] || "",
    totalTrips:     int(r["Total Trips (This Month)"]),
    // Actual per-vehicle policy premium from the Cars tab — displayed in the
    // fleet table's Insurance column. Defaults to the $300/mo cap when the
    // column is blank or missing, so no manual entry is required; enter an
    // actual premium on the Cars tab only when it differs from the cap.
    monthlyInsurance: num(r["Monthly Insurance ($)"]) || INSURANCE_CAP_MONTHLY,
  }));
}

function normalizeDrivers(rows) {
  return rows.map(r => ({
    id:                  r["Driver ID"]               || "",
    name:                r["Full Name"]               || "",
    phone:               r["Phone"] || r["Phone Number"] || "",
    // Mirrors the Cars tab pattern — defaults to "Active" so existing sheets
    // with no Status column keep working with no changes required. Set a
    // driver to "Inactive" (instead of deleting the row) when they leave the
    // program, so historical payments/records stay intact but they drop out
    // of active counts and lists.
    status:              r["Status"] || "Active",
    city:                r["City"]                    || "",
    car:                 r["Assigned Car ID"]         || "",
    weeklyRate:          num(r["Weekly Rate ($)"]),
    startDate:           r["Driver Start Date"]       || "",
    weeksActive:         int(r["Weeks Active"]),
    paymentsMade:        int(r["Total Payments Made"]),
    paymentsRequired:    int(r["Payments Required (78)"]) || 78,
    paid:                num(r["Amount Paid ($)"]),
    targetAmount:        num(r["Target Amount ($)"]),
    amountRemaining:     num(r["Amount Remaining ($)"]),
    progressPct:         num(r["Progress (%)"]),
    projectedOwnershipDate: r["Projected Ownership Date"] || "",
    missedPayments:      int(r["Missed Payments (12mo)"]),
    eligibility:         r["Eligibility Status"]      || "Standard",
    onTrack:             ["Ownership Track","At Risk","Title Eligible"].includes(r["Eligibility Status"]),
    owed:                num(r["Amount Remaining ($)"]),
    notes:               r["Notes"]                   || "",
  }));
}

// ─── VENDOR HELPERS ──────────────────────────────────────────────────────────
// The 🔧 Repairs tab keeps the shop in one "Vendor / Shop" cell, usually as
// "Name - City, TX" (a comma after the name also works). parseVendor splits it
// so the UI can show the shop name big and the location small. Contact info
// comes from an optional column — any ONE of the headers below. Enter a shop's
// phone once and every other row for that same shop picks it up automatically.
const VENDOR_CONTACT_HEADERS = ["Vendor Phone", "Vendor Contact", "Shop Phone", "Shop Contact", "Vendor Phone / Contact", "Contact"];
const PHONE_RE = /(?:\+?1[\s.-]?)?\(?(\d{3})\)?[\s.-]?(\d{3})[\s.-]?(\d{4})/;

function parseVendor(raw) {
  const s = String(raw || "").trim().replace(/\s+/g, " ");
  if (!s) return { name:"", location:"" };
  const dash = s.search(/\s[-–—]\s/);
  if (dash > 0) return { name: s.slice(0, dash).trim(), location: s.slice(dash).replace(/^\s[-–—]\s/, "").trim() };
  const comma = s.indexOf(",");
  if (comma > 0) return { name: s.slice(0, comma).trim(), location: s.slice(comma + 1).trim() };
  return { name: s, location: "" };
}

// Returns { display, href } — display is the cell as typed (so a contact
// person's name survives), href is a tap-to-call link when a phone number is
// found in it (null otherwise).
function parseContact(raw) {
  const s = String(raw || "").trim();
  if (!s) return null;
  const m = s.match(PHONE_RE);
  return { display: m ? s.replace(m[0], `(${m[1]}) ${m[2]}-${m[3]}`) : s, href: m ? `tel:+1${m[1]}${m[2]}${m[3]}` : null };
}

function normalizeRepairs(rows) {
  const repairs = rows.map(r => {
    const vendorRaw = r["Vendor / Shop"] || "";
    const contactRaw = VENDOR_CONTACT_HEADERS.map(h => r[h]).find(v => v) || "";
    return {
      carId:   r["Car ID"]      || "",
      date:    r["Date"]        || "",
      desc:    r["Description"] || "",
      cost:    num(r["Cost ($)"]),
      type:    r["Repair Type"] || "",
      vendor:  vendorRaw,                        // original text, kept for compatibility
      vendorName:     parseVendor(vendorRaw).name,
      vendorLocation: parseVendor(vendorRaw).location,
      vendorContact:  contactRaw,
      notes:   r["Notes"]       || "",
      // Odometer reading at time of service — optional column ("Mileage at
      // Service"). Powers the maintenance-due predictions below; repairs
      // logged without it just won't produce a prediction for that service.
      mileage: int(r["Mileage at Service"]) || 0,
    };
  });
  // Fill blank contacts from any other row for the same shop (same name +
  // location), so contact info only has to be typed once per shop.
  const key = r => r.vendor.toLowerCase().replace(/[^a-z0-9]/g, "");
  const known = {};
  repairs.forEach(r => { if (r.vendorContact && key(r)) known[key(r)] ||= r.vendorContact; });
  repairs.forEach(r => { if (!r.vendorContact && key(r)) r.vendorContact = known[key(r)] || ""; });
  return repairs;
}

function normalizePayments(rows) {
  return rows.map(r => {
    const amount          = num(r["Amount ($)"]);
    const insuranceCredit = num(r["Insurance Credit ($)"]);
    // Earned Revenue = cash received + insurance the driver paid on our behalf.
    // If the sheet column is blank, reconstruct it so revenue is never understated.
    const earnedRevenue   = num(r["Earned Revenue ($)"]) || (amount + insuranceCredit);
    return {
      receiptNum: r["Receipt #"]     || "",
      driverId:   r["Driver ID"]     || "",
      name:       r["Driver Name"]   || "",
      vehicle:    r["Vehicle"]       || "",
      email:      r["Email"]         || "",
      weekStart:  r["Week Start"]    || "",
      weekEnd:    r["Week End"]      || "",
      date:       r["Week Start"]    || "",
      amount,
      weeklyRate: num(r["Weekly Rate ($)"]),
      method:     r["Payment Method"] || "",
      status:     (r["Status (Paid)"] || "").toString().toUpperCase() === "TRUE" ? "Paid" : "Pending",
      // "Receipt Link" (col L) now displays a friendly name via a =HYPERLINK()
      // formula, so its API value is the display text, not a URL. The raw,
      // plain-text Drive URL lives in "Receipt URL (Raw)" (col R) instead —
      // falls back to the old column in case that header isn't added yet.
      receiptLink: r["Receipt URL (Raw)"] || r["Receipt Link"] || "",
      dateSent:   r["Date Sent"]     || "",
      notes:      r["Notes"]         || "",
      insuranceCredit,
      earnedRevenue,
      carId:      r["Car ID"]        || "",
    };
  });
}

function normalizeExpenses(rows) {
  return rows.map(r => ({
    month:           r["Month"]                || "",
    activeCars:      int(r["Active Cars"]),
    insuranceBudget: num(r["Insurance Budget"]),
    insuranceActual: num(r["Insurance Actual"]),
    oilBudget:       num(r["Oil Changes Budget"]),
    oilActual:       num(r["Oil Changes Actual"]),
    trackBudget:     num(r["Tracking Budget"]),
    trackActual:     num(r["Tracking Actual"]),
    maintBudget:     num(r["Maintenance Budget"]),
    maintActual:     num(r["Maintenance Actual"]),
    adsBudget:       num(r["Ads & Admin Budget"]),
    adsActual:       num(r["Ads & Admin Actual"]),
    totalBudget:     num(r["Total Budget"]),
    totalActual:     num(r["Total Actual"]),
    variance:        num(r["Variance"]),
    grossRevenue:    num(r["Gross Revenue"]),
    netAfterExpenses:num(r["Net After Expenses"]),
  })).filter(r => r.month !== "");
}

// ─── OIL-CHANGE REPAIR RECLASSIFICATION ─────────────────────────────────────
// A repair logged in 🔧 Repairs whose Repair Type or Description contains
// "oil" is an oil change, even if nobody separately re-entered it on the
// 💸 Expenses tab's "Oil Changes Actual" cell. isOilRepair() finds those rows;
// monthLabel() formats a date the same way the Expenses tab's "Month" column
// reads (e.g. "Jun 2026"), so repair-tab dollars can be grouped into the same
// monthly buckets as the manually-entered sheet rows.
const isOilRepair = r => /oil/i.test(r.type) || /oil/i.test(r.desc);
const monthLabel  = dateStr => {
  const d = toDate(dateStr);
  return d.getTime() === 0 ? "" : d.toLocaleDateString("en-US", { month:"short", year:"numeric" });
};

// ─── PROFIT ENGINE ───────────────────────────────────────────────────────────
// True Net Profit = Earned Revenue − Repairs − Insurance − Other logged opex.
//   • Earned Revenue: cash collected + insurance credits (drivers paying the
//     insurer directly on FlexEarn's behalf still counts as revenue earned).
//   • Insurance: insurance credits (per car, from Payments) + "Insurance
//     Actual" paid directly (fleet-level, from 💸 Expenses).
//   • Other opex: Oil, Tracking, Ads & Admin actuals from 💸 Expenses.
//     "Maintenance Actual" is intentionally EXCLUDED here because repairs are
//     already counted from the 🔧 Repairs tab — including both would
//     double-count the same dollars.
const fmt       = n  => (n < 0 ? "-$" : "$") + Math.abs(Math.round(n)).toLocaleString();
const pct       = n  => Math.round(n) + "%";
// Formats a raw phone string as (XXX) XXX-XXXX when it's a clean 10-digit
// US number; otherwise returns whatever was entered as-is (e.g. already
// formatted, or has an extension) so we never mangle sheet data.
const fmtPhone  = p  => {
  const digits = String(p || "").replace(/\D/g, "");
  if (digits.length === 10) return `(${digits.slice(0,3)}) ${digits.slice(3,6)}-${digits.slice(6)}`;
  if (digits.length === 11 && digits[0] === "1") return `(${digits.slice(1,4)}) ${digits.slice(4,7)}-${digits.slice(7)}`;
  return p || "";
};
const netProfit = c  => c.revenue - c.maintenanceCost - (c.insuranceAccrued || 0);
const totalInv  = c  => c.totalStartup + c.maintenanceCost;
const roi       = c  => totalInv(c) > 0 ? ((c.revenue - totalInv(c)) / totalInv(c) * 100) : 0;
const payoff    = c  => c.totalStartup > 0 ? Math.min(100, Math.round(c.revenue / c.totalStartup * 100)) : 0;

function calcMaintenance(carId, repairs) {
  return repairs.filter(r => r.carId === carId).reduce((s, r) => s + r.cost, 0);
}

// ─── MAINTENANCE PREDICTIONS ─────────────────────────────────────────────────
// Predicts when each tracked service is next due from mileage alone: it finds
// the car's most recent repair matching each type (by keyword, against either
// the Repair Type or Description column), then compares its logged odometer
// reading to the car's Current Mileage. Miles-remaining is exact math. The
// *date* estimate is necessarily a guess on top of that — it's derived from
// the car's average miles/day since that last service, so a car that's been
// sitting idle will still show correct miles-to-due even if the date drifts.
// Brake pad life especially varies with driving style/city traffic — treat
// that one interval as a rough placeholder, not a hard number.
// Requires a "Mileage at Service" column on the 🔧 Repairs tab; repairs
// logged without it are skipped for that service type.
const MAINTENANCE_SCHEDULE = [
  { key:"oil",    label:"Oil Change",    match:/oil/i,           intervalMiles:5000  },
  { key:"tires",  label:"Tire Rotation", match:/tire|rotation/i, intervalMiles:6000  },
  { key:"brakes", label:"Brake Pads",    match:/brake/i,         intervalMiles:35000 },
];

function predictMaintenance(car, repairs) {
  const carRepairs = repairs.filter(r => r.carId === car.id);
  const now = new Date();
  return MAINTENANCE_SCHEDULE.map(svc => {
    const matches = carRepairs
      .filter(r => r.mileage > 0 && (svc.match.test(r.type) || svc.match.test(r.desc)))
      .sort((a, b) => toDate(b.date) - toDate(a.date));
    const last = matches[0];
    if (!last) return { ...svc, hasData:false };

    const milesSince     = Math.max(0, car.mileage - last.mileage);
    const milesRemaining = svc.intervalMiles - milesSince;
    const daysSince       = Math.max(1, Math.round((now - toDate(last.date)) / 86400000));
    const dailyMiles      = milesSince / daysSince;
    const estDate = dailyMiles > 0
      ? new Date(now.getTime() + Math.round(milesRemaining / dailyMiles) * 86400000)
      : null;

    return {
      ...svc, hasData:true,
      lastDate: last.date, lastMileage: last.mileage, lastVendor: last,
      milesSince, milesRemaining,
      overdue:  milesRemaining <= 0,
      dueSoon:  milesRemaining > 0 && milesRemaining <= svc.intervalMiles * 0.1,
      estDate,
    };
  });
}

const condColor  = c => c === "Excellent" ? T.green  : c === "Good" ? T.blue  : T.red;
const condBg     = c => c === "Excellent" ? T.greenBg: c === "Good" ? T.blueBg: T.redBg;
const statColor  = s => s === "Active" ? T.green : s === "Maintenance" ? T.gold : T.red;
const statBg     = s => s === "Active" ? T.greenBg: s === "Maintenance" ? T.goldBg: T.redBg;
const eligColor  = e => e === "Title Eligible" ? T.green : e === "Ownership Eligible" ? T.green : e === "Ownership Track" ? T.purple : e === "At Risk" ? T.gold : e === "Ineligible" ? T.red : T.textSub;
const eligBg     = e => e === "Title Eligible" ? T.greenBg : e === "Ownership Eligible" ? T.greenBg : e === "Ownership Track" ? T.purpleBg : e === "At Risk" ? T.goldBg : e === "Ineligible" ? T.redBg : "#f0ede8";

// ─── UI PRIMITIVES ───────────────────────────────────────────────────────────
const Badge = ({ label, color, bg }) => (
  <span style={{ background: bg, color, border:`1px solid ${color}33`, borderRadius:4, padding:"2px 9px", fontSize:11, fontWeight:700, letterSpacing:"0.04em", whiteSpace:"nowrap", display:"inline-block" }}>
    {label}
  </span>
);

const SectionLabel = ({ children }) => (
  <div style={{ fontSize:10, fontWeight:800, color:T.textSub, textTransform:"uppercase", letterSpacing:"0.14em", marginBottom:14 }}>{children}</div>
);

// Shop name with location underneath and a tap-to-call number. Used anywhere a
// repair record is shown, so a vendor looks the same across the dashboard.
// `inline` = single compact line ("Shop · (555) 123-4567") for tight spaces.
const VendorCell = ({ repair, inline = false }) => {
  if (!repair || !repair.vendorName) return <span style={{ color:T.textSub }}>—</span>;
  const contact = parseContact(repair.vendorContact);
  const phone = contact && (contact.href
    ? <a href={contact.href} onClick={e=>e.stopPropagation()} style={{ color:T.blue, fontWeight:700, textDecoration:"none", whiteSpace:"nowrap" }}>{contact.display}</a>
    : <span style={{ color:T.textMid, fontWeight:600 }}>{contact.display}</span>);
  if (inline) {
    return (
      <span>
        <span style={{ color:T.textMid, fontWeight:700 }}>{repair.vendorName}</span>
        {repair.vendorLocation && <span> · {repair.vendorLocation}</span>}
        {phone && <div style={{ marginTop:1 }}>{phone}</div>}
      </span>
    );
  }
  return (
    <div style={{ lineHeight:1.35 }}>
      <div style={{ fontSize:13, fontWeight:700, color:T.text }}>{repair.vendorName}</div>
      {repair.vendorLocation && <div style={{ fontSize:11, color:T.textSub }}>{repair.vendorLocation}</div>}
      {phone && <div style={{ fontSize:12, marginTop:1 }}>{phone}</div>}
    </div>
  );
};

// ─── COLLAPSIBLE SECTION ─────────────────────────────────────────────────────
// Wraps a chunk of the page behind a click-to-open/collapse header, for
// sections that can get long — weekly tables, payment history, etc. Defaults
// to open on desktop-sized pages so nothing hides on first load; pass
// defaultOpen={false} for anything that should start collapsed.
const CollapsibleSection = ({ title, defaultOpen = true, id, children }) => {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div id={id} style={{ scrollMarginTop:132 }}>
      <div onClick={()=>setOpen(o=>!o)} style={{ display:"flex", alignItems:"center", justifyContent:"space-between", cursor:"pointer", marginBottom: open ? 14 : 0, userSelect:"none" }}>
        <div style={{ fontSize:10, fontWeight:800, color:T.textSub, textTransform:"uppercase", letterSpacing:"0.14em" }}>{title}</div>
        <span style={{ fontSize:11, fontWeight:800, color:T.orange, display:"flex", alignItems:"center", gap:5, background:T.orangeL, border:`1px solid ${T.orange}55`, borderRadius:20, padding:"5px 12px", whiteSpace:"nowrap", transition:"background 0.15s" }}
          onMouseEnter={e=>{ e.currentTarget.style.background=T.orange+"22"; }}
          onMouseLeave={e=>{ e.currentTarget.style.background=T.orangeL; }}>
          {open ? "▾ Collapse" : "▸ Expand"}
        </span>
      </div>
      {open && children}
    </div>
  );
};

const BackBtn = ({ label, onClick }) => (
  <button onClick={onClick} style={{ background:"none", border:`1px solid ${T.border2}`, color:T.textMid, borderRadius:6, padding:"6px 14px", cursor:"pointer", fontSize:12, fontWeight:600, marginBottom:24, fontFamily:"inherit" }}>
    ← {label}
  </button>
);

const KpiCard = ({ label, value, sub, accent, onClick }) => (
  <div onClick={onClick} style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:10, padding:"16px 18px", cursor:onClick?"pointer":"default", flex:1, minWidth:130, transition:"box-shadow 0.2s,transform 0.15s", boxShadow:"0 1px 3px #0000000a" }}
    onMouseEnter={e=>{ if(onClick){e.currentTarget.style.boxShadow=`0 4px 16px ${accent}22`;e.currentTarget.style.transform="translateY(-2px)";}}}
    onMouseLeave={e=>{ e.currentTarget.style.boxShadow="0 1px 3px #0000000a";e.currentTarget.style.transform="translateY(0)";}}>
    <div style={{ fontSize:10, color:T.textSub, textTransform:"uppercase", letterSpacing:"0.12em", fontWeight:700, marginBottom:6 }}>{label}</div>
    <div style={{ fontSize:26, fontWeight:800, color:accent||T.text, fontFamily:"'Barlow Condensed',sans-serif", lineHeight:1, letterSpacing:"-0.01em" }}>{value}</div>
    {sub && <div style={{ fontSize:11, color:T.textSub, marginTop:3 }}>{sub}</div>}
  </div>
);

// ─── P&L HERO ────────────────────────────────────────────────────────────────
// The one number that owns the page: true Net Profit, backed by a visual
// waterfall (Revenue → each expense → Net). This replaces the row of seven
// equal KPI boxes — it stays exactly this size whether the fleet has 6 cars
// or 600, because it summarizes dollars, not vehicles.
const PnLHero = ({ pnl, onSegmentClick }) => {
  const { revenue, repairs, insurance, otherOpex, net } = pnl;
  const segs = [
    { label:"Maint. & Repairs",   value:repairs,   color:T.gold },
    { label:"Insurance", value:insurance, color:T.blue },
    { label:"Other opex", value:otherOpex, color:T.textSub },
  ].filter(s => s.value > 0);
  const netPct = revenue > 0 ? Math.max(0, net / revenue * 100) : 0;
  const margin = revenue > 0 ? (net / revenue * 100) : 0;

  return (
    <div style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:14, boxShadow:"0 1px 3px #0000000a", padding:"24px 28px", marginBottom:14, display:"flex", gap:36, flexWrap:"wrap", alignItems:"center" }}>
      {/* The number */}
      <div style={{ minWidth:210 }}>
        <div style={{ fontSize:10, color:T.textSub, textTransform:"uppercase", letterSpacing:"0.14em", fontWeight:800, marginBottom:6 }}>
          Net Profit · All Time
        </div>
        <div style={{ fontSize:52, fontWeight:900, lineHeight:1, fontFamily:"'Barlow Condensed',sans-serif", color: net >= 0 ? T.green : T.red, letterSpacing:"-0.01em" }}>
          {fmt(net)}
        </div>
        <div style={{ fontSize:12, color:T.textMid, marginTop:6, fontWeight:600 }}>
          {pct(margin)} margin · after repairs, insurance &amp; opex
        </div>
      </div>

      {/* The waterfall */}
      <div style={{ flex:1, minWidth:320 }}>
        <div style={{ display:"flex", justifyContent:"space-between", marginBottom:6 }}>
          <span style={{ fontSize:11, fontWeight:700, color:T.green }}>Earned Revenue {fmt(revenue)}</span>
          <span style={{ fontSize:11, fontWeight:700, color:net>=0?T.green:T.red }}>Net {fmt(net)}</span>
        </div>
        <div style={{ display:"flex", height:26, borderRadius:6, overflow:"hidden", border:`1px solid ${T.border}` }}>
          <div title={`Net Profit ${fmt(net)}`} style={{ width:`${netPct}%`, background:`linear-gradient(90deg,${T.green},#2a9a62)`, transition:"width 0.5s" }} />
          {segs.map(s => (
            <div key={s.label} title={`${s.label} ${fmt(s.value)} — click for breakdown`}
              onClick={() => onSegmentClick && onSegmentClick(s.label)}
              onMouseEnter={e=>{ e.currentTarget.style.opacity=0.7; }}
              onMouseLeave={e=>{ e.currentTarget.style.opacity=0.45; }}
              style={{ width:`${revenue>0 ? s.value/revenue*100 : 0}%`, background:s.color, opacity:0.45, borderLeft:`2px solid ${T.surface}`, transition:"width 0.5s,opacity 0.15s", cursor:onSegmentClick?"pointer":"default" }} />
          ))}
        </div>
        <div style={{ display:"flex", gap:18, marginTop:10, flexWrap:"wrap" }}>
          {[["Maint. & Repairs",repairs,T.gold],["Insurance",insurance,T.blue],["Other Opex",otherOpex,T.textSub]].map(([l,v,c])=>(
            <div key={l} onClick={() => onSegmentClick && onSegmentClick(l)}
              style={{ display:"flex", alignItems:"center", gap:6, cursor:onSegmentClick?"pointer":"default" }}>
              <span style={{ width:8, height:8, borderRadius:2, background:c, opacity:0.6, display:"inline-block" }} />
              <span style={{ fontSize:11, color:T.textMid, fontWeight:600, textDecoration:onSegmentClick?"underline":"none", textDecorationColor:T.border, textUnderlineOffset:3 }}>{l}</span>
              <span style={{ fontSize:11, color:T.text, fontWeight:800 }}>{fmt(v)}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

// ─── FLEET INSIGHTS ──────────────────────────────────────────────────────────
// Two short, comparative callouts — not just "here's a number" but "here's
// why it's worth a look." Sits right under Needs Attention since it's the
// same kind of read: what to learn from, before the day's to-do list.
const FleetInsights = ({ bestCar, worstCar, fleetAvgMaintRatio, onSelectCar }) => {
  if (!bestCar && !worstCar) return null;
  const cards = [];
  if (bestCar) {
    const r = roi(bestCar);
    const bRatio = bestCar.maintenanceCost / bestCar.revenue;
    cards.push({
      key:"best", level:"good", label:"Best Performer",
      car: bestCar,
      headline: `${bestCar.id} · ${bestCar.year} ${bestCar.make} ${bestCar.model}`,
      stat: `${r>=0?"+":""}${pct(r)} ROI`,
      note: `Maintenance is only ${pct(bRatio*100)} of its revenue — worth checking what's working (driver, city, service vendor) and repeating it.`,
    });
  }
  if (worstCar && worstCar.revenue > 0) {
    const wRatio = worstCar.maintenanceCost / worstCar.revenue;
    if (!bestCar || worstCar.id !== bestCar.id) {
      cards.push({
        key:"worst", level: wRatio > 0.4 ? "bad" : "watch", label:"Needs A Look",
        car: worstCar,
        headline: `${worstCar.id} · ${worstCar.year} ${worstCar.make} ${worstCar.model}`,
        stat: `${pct(wRatio*100)} to maintenance`,
        note: `Fleet average is ${pct(fleetAvgMaintRatio*100)} — this one's running well above it. Worth comparing mileage, vendor, or condition against ${bestCar ? bestCar.id : "your best cars"}.`,
      });
    }
  }
  if (cards.length === 0) return null;
  return (
    <div style={{ marginBottom:24 }}>
      <SectionLabel>Fleet Insights</SectionLabel>
      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(280px,1fr))", gap:12 }}>
        {cards.map(c => (
          <div key={c.key} onClick={()=>onSelectCar(c.car)}
            style={{ background:T.surface, border:`1px solid ${c.level==="good"?T.green:c.level==="bad"?T.red:T.gold}33`, borderLeft:`4px solid ${c.level==="good"?T.green:c.level==="bad"?T.red:T.gold}`, borderRadius:10, padding:"14px 16px", cursor:"pointer", boxShadow:"0 1px 3px #0000000a" }}
            onMouseEnter={e=>{ e.currentTarget.style.boxShadow="0 2px 8px #00000014"; }}
            onMouseLeave={e=>{ e.currentTarget.style.boxShadow="0 1px 3px #0000000a"; }}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:6 }}>
              <span style={{ fontSize:10, fontWeight:800, textTransform:"uppercase", letterSpacing:"0.1em", color:c.level==="good"?T.green:c.level==="bad"?T.red:T.gold }}>{c.label}</span>
              <span style={{ fontSize:13, fontWeight:800, color:T.text }}>{c.stat}</span>
            </div>
            <div style={{ fontSize:14, fontWeight:700, color:T.text, marginBottom:6 }}>{c.headline}</div>
            <div style={{ fontSize:12, color:T.textMid, lineHeight:1.5 }}>{c.note}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

// A single quiet line of fleet stats — replaces the wall of KPI boxes.
// Text scales gracefully; it never grows with fleet size.
const StatStrip = ({ items }) => (
  <div style={{ display:"flex", gap:0, flexWrap:"wrap", background:T.surface, border:`1px solid ${T.border}`, borderRadius:10, boxShadow:"0 1px 3px #0000000a", marginBottom:24, overflow:"hidden" }}>
    {items.map(([label, value, accent, sub], i) => (
      <div key={label} style={{ flex:1, minWidth:120, padding:"12px 18px", borderLeft: i===0 ? "none" : `1px solid ${T.border}` }}>
        <div style={{ fontSize:9, color:T.textSub, textTransform:"uppercase", letterSpacing:"0.12em", fontWeight:700 }}>{label}</div>
        <div style={{ fontSize:20, fontWeight:800, color:accent||T.text, fontFamily:"'Barlow Condensed',sans-serif", lineHeight:1.15 }}>{value}</div>
        {sub && <div style={{ fontSize:10, color:T.textSub }}>{sub}</div>}
      </div>
    ))}
  </div>
);

// ─── ALERTS ──────────────────────────────────────────────────────────────────
// What an operator actually needs on login: what's wrong, before what's fine.
const AlertsStrip = ({ alerts }) => {
  if (alerts.length === 0) return null;
  return (
    <div style={{ marginBottom:24 }}>
      <SectionLabel>Needs Attention ({alerts.length})</SectionLabel>
      <div style={{ display:"grid", gap:8 }}>
        {alerts.map((a, i) => (
          <div key={i} onClick={a.onClick} style={{ display:"flex", alignItems:"center", gap:12, background: a.level==="red"?T.redBg:T.goldBg, border:`1px solid ${a.level==="red"?T.red:T.gold}33`, borderRadius:8, padding:"10px 14px", cursor:a.onClick?"pointer":"default" }}>
            <span style={{ fontSize:14 }}>{a.level==="red"?"⛔":"⚠"}</span>
            <span style={{ fontSize:13, fontWeight:700, color:a.level==="red"?T.red:T.gold }}>{a.title}</span>
            <span style={{ fontSize:12, color:T.textMid }}>{a.detail}</span>
            {a.onClick && <span style={{ marginLeft:"auto", fontSize:12, color:T.textSub, fontWeight:700 }}>View →</span>}
          </div>
        ))}
      </div>
    </div>
  );
};

const PayoffBar = ({ car, compact }) => {
  const p = payoff(car);
  const r = roi(car);
  return (
    <div>
      {!compact && <div style={{ display:"flex", justifyContent:"space-between", marginBottom:4 }}>
        <span style={{ fontSize:11, color:T.textSub, fontWeight:700, textTransform:"uppercase", letterSpacing:"0.08em" }}>Vehicle Payoff</span>
        <span style={{ fontSize:11, fontWeight:800, color:p>=100?T.green:T.orange }}>{pct(p)}</span>
      </div>}
      <div style={{ background:T.border, borderRadius:4, height:compact?5:8, overflow:"hidden" }}>
        <div style={{ width:pct(Math.min(p,100)), background:p>=100?T.green:`linear-gradient(90deg,${T.orange},${T.orangeD})`, height:"100%", borderRadius:4 }} />
      </div>
      {!compact && <div style={{ display:"flex", justifyContent:"space-between", marginTop:4 }}>
        <span style={{ fontSize:11, color:T.textSub }}>Recovered: {fmt(car.revenue)} of {fmt(car.totalStartup)} startup</span>
        <span style={{ fontSize:11, fontWeight:700, color:r>=0?T.green:T.red }}>ROI {r>=0?"+":""}{pct(r)}</span>
      </div>}
    </div>
  );
};

// ─── DONUT CHART (dependency-free SVG) ──────────────────────────────────────
// Plain stroke-dasharray donut — no charting library required. Each slice is
// its own <circle>, clickable via onSegmentClick, so callers can drive a
// drill-down panel off whichever slice was clicked.
const DonutChart = ({ segments, size = 168, thickness = 24, centerLabel, centerValue, centerSub, activeKey, onSegmentClick }) => {
  const total = segments.reduce((s, seg) => s + Math.max(0, seg.value), 0);
  const r = (size - thickness) / 2;
  const cx = size / 2, cy = size / 2;
  const circumference = 2 * Math.PI * r;
  let offset = 0;
  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
      <circle cx={cx} cy={cy} r={r} fill="none" stroke={T.border} strokeWidth={thickness} />
      {total > 0 && segments.filter(s => s.value > 0).map((seg) => {
        const dash = (seg.value / total) * circumference;
        const isActive = activeKey === seg.key;
        const el = (
          <circle key={seg.key} cx={cx} cy={cy} r={r} fill="none" stroke={seg.color}
            strokeWidth={isActive ? thickness + 4 : thickness}
            strokeDasharray={`${dash} ${circumference - dash}`}
            strokeDashoffset={-offset}
            transform={`rotate(-90 ${cx} ${cy})`}
            style={{ cursor: onSegmentClick ? "pointer" : "default", transition:"stroke-width 0.15s, opacity 0.15s", opacity: activeKey && !isActive ? 0.55 : 1 }}
            onClick={() => onSegmentClick && onSegmentClick(seg)} />
        );
        offset += dash;
        return el;
      })}
      <text x={cx} y={cy - 8} textAnchor="middle" fontSize="10" fontWeight="700" fill={T.textSub} style={{ textTransform:"uppercase", letterSpacing:"0.08em" }}>{centerLabel}</text>
      <text x={cx} y={cy + 14} textAnchor="middle" fontSize="21" fontWeight="900" fill={T.text} fontFamily="'Barlow Condensed',sans-serif">{centerValue}</text>
      {centerSub && <text x={cx} y={cy + 30} textAnchor="middle" fontSize="9" fill={T.textSub}>{centerSub}</text>}
    </svg>
  );
};

// ─── CAR FINANCIAL DONUT + DRILL-DOWN ───────────────────────────────────────
// Splits this car's Earned Revenue into where it went — Maintenance & Repairs,
// Insurance, and what's left as Net Profit. Click a slice for the detail
// behind that number: Maint. & Repairs drills into individual repair records
// (oil changes called out, since they're now tracked separately — see
// isOilRepair), Insurance shows the premium math, Net Profit recaps the
// revenue-minus-costs arithmetic.
const CarFinancialDonut = ({ car, repairs }) => {
  const [active, setActive] = useState(null);
  const net = netProfit(car);
  const segments = [
    { key:"maint", label:"Maint. & Repairs", value: car.maintenanceCost, color: T.gold },
    { key:"ins",   label:"Insurance",        value: car.insuranceAccrued || 0, color: T.blue },
    { key:"net",   label:"Net Profit",       value: Math.max(0, net), color: T.green },
  ];
  const carRepairs = repairs.filter(rp => rp.carId === car.id);
  const byType = {};
  carRepairs.forEach(rp => {
    const label = isOilRepair(rp) ? "Oil Change" : (rp.type || "Uncategorized");
    (byType[label] ||= { label, cost:0, count:0 }).cost += rp.cost;
    byType[label].count += 1;
  });
  const typeRows = Object.values(byType).sort((a,b)=>b.cost-a.cost);

  return (
    <div style={{ display:"flex", flexDirection:"column", alignItems:"center", minWidth:220 }}>
      <div style={{ fontSize:11, fontWeight:700, color:T.textSub, textTransform:"uppercase", letterSpacing:"0.08em", marginBottom:10, alignSelf:"flex-start" }}>
        Revenue Breakdown
      </div>
      <DonutChart segments={segments} centerLabel="Revenue" centerValue={fmt(car.revenue)} centerSub="earned, all-time"
        activeKey={active} onSegmentClick={seg => setActive(active === seg.key ? null : seg.key)} />
      <div style={{ display:"flex", flexDirection:"column", gap:6, width:"100%", marginTop:12 }}>
        {segments.map(seg => (
          <div key={seg.key} onClick={()=>setActive(active===seg.key?null:seg.key)}
            style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"5px 8px", borderRadius:6, cursor:"pointer", background: active===seg.key ? T.surface2 : "transparent" }}>
            <span style={{ display:"flex", alignItems:"center", gap:7, fontSize:12, color:T.textMid, fontWeight:600 }}>
              <span style={{ width:9, height:9, borderRadius:"50%", background:seg.color, display:"inline-block" }} />
              {seg.label}
            </span>
            <span style={{ fontSize:12, fontWeight:800, color:T.text }}>{fmt(seg.value)}</span>
          </div>
        ))}
      </div>
      {net < 0 && (
        <div style={{ marginTop:8, fontSize:11, color:T.red, fontWeight:700, textAlign:"center" }}>
          ⚠ Net Profit is negative ({fmt(net)}) — not shown as a slice above.
        </div>
      )}

      {/* Drill-down panel */}
      {active === "maint" && (
        <div style={{ width:"100%", marginTop:14, paddingTop:14, borderTop:`1px solid ${T.border}` }}>
          <div style={{ fontSize:11, fontWeight:700, color:T.textSub, textTransform:"uppercase", letterSpacing:"0.08em", marginBottom:8 }}>By Repair Type</div>
          {typeRows.length === 0 ? <div style={{ fontSize:12, color:T.textSub }}>No repairs logged.</div> : typeRows.map(row => (
            <div key={row.label} style={{ display:"flex", justifyContent:"space-between", padding:"5px 0", fontSize:12 }}>
              <span style={{ color: row.label==="Oil Change" ? T.gold : T.textMid, fontWeight: row.label==="Oil Change" ? 700 : 500 }}>
                {row.label} <span style={{ color:T.textSub }}>×{row.count}</span>
              </span>
              <span style={{ fontWeight:700, color:T.text }}>{fmt(row.cost)}</span>
            </div>
          ))}
        </div>
      )}
      {active === "ins" && (
        <div style={{ width:"100%", marginTop:14, paddingTop:14, borderTop:`1px solid ${T.border}`, fontSize:12, color:T.textMid, lineHeight:1.8 }}>
          <div style={{ display:"flex", justifyContent:"space-between" }}><span>Monthly premium</span><span style={{ fontWeight:700, color:T.text }}>{fmt(car.monthlyInsurance)}</span></div>
          <div style={{ display:"flex", justifyContent:"space-between" }}><span>Weeks active</span><span style={{ fontWeight:700, color:T.text }}>{car.driverObj?.weeksActive ?? 0}</span></div>
          <div style={{ display:"flex", justifyContent:"space-between" }}><span>Credits collected from driver</span><span style={{ fontWeight:700, color:T.text }}>{fmt(car.insuranceCost || 0)}</span></div>
          <div style={{ fontSize:11, color:T.textSub, marginTop:6 }}>Accrued = monthly premium × 12 ÷ 52 × weeks active.</div>
        </div>
      )}
      {active === "net" && (
        <div style={{ width:"100%", marginTop:14, paddingTop:14, borderTop:`1px solid ${T.border}`, fontSize:12, color:T.textMid, lineHeight:1.8 }}>
          <div style={{ display:"flex", justifyContent:"space-between" }}><span>Earned Revenue</span><span style={{ fontWeight:700, color:T.green }}>{fmt(car.revenue)}</span></div>
          <div style={{ display:"flex", justifyContent:"space-between" }}><span>− Maint. &amp; Repairs</span><span style={{ fontWeight:700, color:T.text }}>{fmt(car.maintenanceCost)}</span></div>
          <div style={{ display:"flex", justifyContent:"space-between" }}><span>− Insurance</span><span style={{ fontWeight:700, color:T.text }}>{fmt(car.insuranceAccrued || 0)}</span></div>
          <div style={{ display:"flex", justifyContent:"space-between", borderTop:`1px solid ${T.border}`, marginTop:4, paddingTop:4 }}><span style={{ fontWeight:700 }}>= Net Profit</span><span style={{ fontWeight:800, color: net>=0?T.green:T.red }}>{fmt(net)}</span></div>
        </div>
      )}
    </div>
  );
};

// ─── SCALABLE LIST CONTROLS ──────────────────────────────────────────────────
// Card grids are pleasant at 6 vehicles and unusable at 60. Past a dozen rows
// the professional pattern is search + a sortable table. Both views are kept:
// cards by default for small fleets, table auto-selected as the fleet grows.
// ─── WEEKLY-BY-CITY TABLE ────────────────────────────────────────────────────
// This table grows by one row every week forever, so on top of living inside
// a CollapsibleSection it defaults to showing only the most recent 8 weeks,
// with a toggle to load the full history when someone actually needs it.
const WeeklyCityTable = ({ rows, recentRows, cityList, fmtD }) => {
  const [showAll, setShowAll] = useState(rows.length <= 8);
  const visible = showAll ? rows : recentRows;
  return (
    <div>
      <div style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, overflow:"auto", boxShadow:"0 1px 3px #0000000a" }}>
        <table style={{ width:"100%", borderCollapse:"collapse", minWidth:640 }}>
          <thead>
            <tr style={{ background:"#1A1612" }}>
              <th style={{ padding:"12px 14px", fontSize:10, fontWeight:700, color:"#fff", textTransform:"uppercase", letterSpacing:"0.1em", textAlign:"left" }}>Week of</th>
              {cityList.map(city => (
                <th key={city} colSpan={3} style={{ padding:"12px 14px", fontSize:10, fontWeight:700, color:"#fff", textTransform:"uppercase", letterSpacing:"0.1em", textAlign:"center", borderLeft:"1px solid #ffffff22" }}>{city}</th>
              ))}
            </tr>
            <tr style={{ background:"#FAF9F7", borderBottom:`1px solid ${T.border}` }}>
              <th style={{ padding:"7px 14px" }}></th>
              {cityList.map(city => (
                ["Revenue","Maint. & Repairs","Net"].map(h => (
                  <th key={city+h} style={{ padding:"7px 10px", fontSize:9, fontWeight:800, color:T.textSub, textTransform:"uppercase", letterSpacing:"0.08em", textAlign:"right", borderLeft: h==="Revenue" ? `1px solid ${T.border}` : "none" }}>{h}</th>
                ))
              ))}
            </tr>
          </thead>
          <tbody>
            {visible.map(({wk, byCity}) => (
              <tr key={+wk} style={{ borderBottom:`1px solid ${T.border}` }}>
                <td style={{ padding:"10px 14px", fontSize:13, fontWeight:700, color:T.text, whiteSpace:"nowrap" }}>{fmtD(wk)}</td>
                {cityList.map(city => {
                  const v = byCity[city];
                  return ["rev","rep","net"].map(k => (
                    <td key={city+k} style={{ padding:"10px 10px", fontSize:12, textAlign:"right", fontWeight: k==="net" ? 800 : 600,
                      color: k==="rev" ? T.green : k==="rep" ? T.gold : (v.net>=0 ? T.green : T.red),
                      borderLeft: k==="rev" ? `1px solid ${T.border}` : "none" }}>
                      {fmt(Math.round(v[k]))}
                    </td>
                  ));
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {rows.length > 8 && (
        <button onClick={()=>setShowAll(s=>!s)} style={{ background:"none", border:`1px solid ${T.border2}`, color:T.orange, borderRadius:6, padding:"6px 14px", cursor:"pointer", fontSize:12, fontWeight:700, fontFamily:"inherit", marginTop:10 }}>
          {showAll ? `Show recent 8 weeks` : `Show all ${rows.length} weeks`}
        </button>
      )}
    </div>
  );
};

const ListControls = ({ search, setSearch, mode, setMode, placeholder, count }) => (
  <div style={{ display:"flex", gap:10, alignItems:"center", marginBottom:14, flexWrap:"wrap" }}>
    <input
      value={search}
      onChange={e=>setSearch(e.target.value)}
      placeholder={placeholder}
      style={{ flex:1, minWidth:220, padding:"9px 14px", border:`1.5px solid ${T.border}`, borderRadius:8, fontSize:13, fontFamily:"inherit", outline:"none", background:T.surface }}
    />
    <span style={{ fontSize:12, color:T.textSub, fontWeight:600 }}>{count} shown</span>
    <div style={{ display:"flex", border:`1px solid ${T.border2}`, borderRadius:7, overflow:"hidden" }}>
      {[["table","☰ Table"],["cards","▦ Cards"]].map(([key,label])=>(
        <button key={key} onClick={()=>setMode(key)} style={{ background:mode===key?T.text:T.surface, color:mode===key?"#fff":T.textMid, border:"none", padding:"7px 14px", cursor:"pointer", fontSize:12, fontWeight:700, fontFamily:"inherit" }}>
          {label}
        </button>
      ))}
    </div>
  </div>
);

const Th = ({ label, sortKey, sort, setSort, align }) => {
  const active = sort.key === sortKey;
  return (
    <th onClick={()=>setSort({ key:sortKey, dir: active && sort.dir==="desc" ? "asc" : "desc" })}
      style={{ textAlign:align||"left", fontSize:10, color:active?T.orange:T.textSub, textTransform:"uppercase", letterSpacing:"0.1em", padding:"10px 12px", fontWeight:800, cursor:"pointer", userSelect:"none", whiteSpace:"nowrap", background:T.surface2, borderBottom:`2px solid ${T.border}` }}>
      {label}{active ? (sort.dir==="desc" ? " ↓" : " ↑") : ""}
    </th>
  );
};

function useSorted(list, sort) {
  return useMemo(() => {
    const copy = [...list];
    copy.sort((a, b) => {
      const av = a[sort.key], bv = b[sort.key];
      const cmp = typeof av === "number" && typeof bv === "number"
        ? av - bv
        : String(av ?? "").localeCompare(String(bv ?? ""), undefined, { numeric:true });
      return sort.dir === "desc" ? -cmp : cmp;
    });
    return copy;
  }, [list, sort]);
}

// ─── FLEET TABLE ─────────────────────────────────────────────────────────────
const FleetTable = ({ cars, onSelect }) => {
  const [sort, setSort] = useState({ key:"net", dir:"desc" });
  const rows = useMemo(() => cars.map(c => ({
    ...c,
    vehicle: `${c.year} ${c.make} ${c.model}`,
    net: netProfit(c),
    payoffPct: payoff(c),
  })), [cars]);
  const sorted = useSorted(rows, sort);
  return (
    <div style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, overflow:"auto", boxShadow:"0 1px 3px #0000000a" }}>
      <table style={{ width:"100%", borderCollapse:"collapse", minWidth:860 }}>
        <thead><tr>
          <Th label="ID"        sortKey="id"        sort={sort} setSort={setSort} />
          <Th label="Vehicle"   sortKey="vehicle"   sort={sort} setSort={setSort} />
          <Th label="City"      sortKey="city"      sort={sort} setSort={setSort} />
          <Th label="Status"    sortKey="status"    sort={sort} setSort={setSort} />
          <Th label="Driver"    sortKey="driver"    sort={sort} setSort={setSort} />
          <Th label="Revenue"   sortKey="revenue"   sort={sort} setSort={setSort} align="right" />
          <Th label="Maint. & Repairs" sortKey="maintenanceCost" sort={sort} setSort={setSort} align="right" />
          <Th label="Insurance" sortKey="insuranceCost"   sort={sort} setSort={setSort} align="right" />
          <Th label="Net"       sortKey="net"       sort={sort} setSort={setSort} align="right" />
          <Th label="Payoff"    sortKey="payoffPct" sort={sort} setSort={setSort} align="right" />
        </tr></thead>
        <tbody>
          {sorted.map(c => (
            <tr key={c.id} onClick={()=>onSelect(c)} style={{ borderBottom:`1px solid ${T.border}`, cursor:"pointer" }}
              onMouseEnter={e=>e.currentTarget.style.background=T.orangeL} onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
              <td style={{ padding:"11px 12px", fontSize:12, color:T.textSub, fontWeight:700 }}>{c.id}</td>
              <td style={{ padding:"11px 12px", fontSize:13, fontWeight:700, color:T.text, whiteSpace:"nowrap" }}>{c.vehicle}</td>
              <td style={{ padding:"11px 12px", fontSize:13, color:T.textMid }}>{c.city}</td>
              <td style={{ padding:"11px 12px" }}><Badge label={c.status} color={statColor(c.status)} bg={statBg(c.status)} /></td>
              <td style={{ padding:"11px 12px", fontSize:13, color:T.textMid }}>{c.driverObj?.name || "—"}</td>
              <td style={{ padding:"11px 12px", fontSize:13, fontWeight:700, color:T.green, textAlign:"right" }}>{fmt(c.revenue)}</td>
              <td style={{ padding:"11px 12px", fontSize:13, color:T.gold, textAlign:"right" }}>{fmt(c.maintenanceCost)}</td>
              <td style={{ padding:"11px 12px", fontSize:13, color:T.blue, textAlign:"right" }}>{c.monthlyInsurance ? fmt(c.monthlyInsurance)+"/mo" : fmt(c.insuranceCost||0)}</td>
              <td style={{ padding:"11px 12px", fontSize:13, fontWeight:800, color:c.net>=0?T.green:T.red, textAlign:"right" }}>{fmt(c.net)}</td>
              <td style={{ padding:"11px 12px", fontSize:12, fontWeight:700, color:c.payoffPct>=100?T.green:T.orange, textAlign:"right" }}>{c.payoffPct}%</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// ─── DRIVERS TABLE ───────────────────────────────────────────────────────────
const DriversTable = ({ drivers, onSelect }) => {
  const [sort, setSort] = useState({ key:"paid", dir:"desc" });
  const sorted = useSorted(drivers, sort);
  return (
    <div style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, overflow:"auto", boxShadow:"0 1px 3px #0000000a" }}>
      <table style={{ width:"100%", borderCollapse:"collapse", minWidth:940 }}>
        <thead><tr>
          <Th label="ID"          sortKey="id"          sort={sort} setSort={setSort} />
          <Th label="Name"        sortKey="name"        sort={sort} setSort={setSort} />
          <Th label="Phone"       sortKey="phone"       sort={sort} setSort={setSort} />
          <Th label="City"        sortKey="city"        sort={sort} setSort={setSort} />
          <Th label="Car"         sortKey="car"         sort={sort} setSort={setSort} />
          <Th label="Weekly"      sortKey="weeklyRate"  sort={sort} setSort={setSort} align="right" />
          <Th label="Paid"        sortKey="paid"        sort={sort} setSort={setSort} align="right" />
          <Th label="Remaining"   sortKey="amountRemaining" sort={sort} setSort={setSort} align="right" />
          <Th label="Progress"    sortKey="progressPct" sort={sort} setSort={setSort} align="right" />
          <Th label="Missed"      sortKey="missedPayments"  sort={sort} setSort={setSort} align="right" />
          <Th label="Eligibility" sortKey="eligibility" sort={sort} setSort={setSort} />
        </tr></thead>
        <tbody>
          {sorted.map(d => (
            <tr key={d.id} onClick={()=>onSelect(d)} style={{ borderBottom:`1px solid ${T.border}`, cursor:"pointer" }}
              onMouseEnter={e=>e.currentTarget.style.background=T.orangeL} onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
              <td style={{ padding:"11px 12px", fontSize:12, color:T.textSub, fontWeight:700 }}>{d.id}</td>
              <td style={{ padding:"11px 12px", fontSize:13, fontWeight:700, color:T.text, whiteSpace:"nowrap" }}>{d.name}</td>
              <td style={{ padding:"11px 12px", fontSize:13, color:T.textMid, whiteSpace:"nowrap" }}>
                {d.phone ? <a href={`tel:${d.phone}`} onClick={e=>e.stopPropagation()} style={{ color:T.orange, fontWeight:600, textDecoration:"none" }}>{fmtPhone(d.phone)}</a> : "—"}
              </td>
              <td style={{ padding:"11px 12px", fontSize:13, color:T.textMid }}>{d.city}</td>
              <td style={{ padding:"11px 12px", fontSize:13, color:T.textMid }}>{d.car||"—"}</td>
              <td style={{ padding:"11px 12px", fontSize:13, color:T.textMid, textAlign:"right" }}>{fmt(d.weeklyRate)}</td>
              <td style={{ padding:"11px 12px", fontSize:13, fontWeight:700, color:T.green, textAlign:"right" }}>{fmt(d.paid)}</td>
              <td style={{ padding:"11px 12px", fontSize:13, color:d.amountRemaining>0?T.orange:T.textSub, textAlign:"right" }}>{fmt(d.amountRemaining)}</td>
              <td style={{ padding:"11px 12px", fontSize:13, fontWeight:700, color:d.progressPct>=100?T.green:T.text, textAlign:"right" }}>{d.progressPct}%</td>
              <td style={{ padding:"11px 12px", fontSize:13, fontWeight:800, color:d.missedPayments>0?T.red:T.textSub, textAlign:"right" }}>{d.missedPayments}</td>
              <td style={{ padding:"11px 12px" }}><Badge label={d.eligibility} color={eligColor(d.eligibility)} bg={eligBg(d.eligibility)} /></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// ─── LOADING / ERROR ──────────────────────────────────────────────────────────
const Spinner = () => (
  <div style={{ display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", minHeight:300, gap:16 }}>
    <div style={{ width:40, height:40, border:`3px solid ${T.border}`, borderTop:`3px solid ${T.orange}`, borderRadius:"50%", animation:"spin 0.8s linear infinite" }} />
    <div style={{ color:T.textSub, fontSize:14 }}>Loading fleet data…</div>
    <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
  </div>
);

const ErrorBanner = ({ message, onRetry }) => (
  <div style={{ background:T.redBg, border:`1px solid ${T.red}33`, borderRadius:10, padding:"20px 24px", marginBottom:24 }}>
    <div style={{ fontWeight:700, color:T.red, marginBottom:6 }}>Unable to load data</div>
    <div style={{ fontSize:13, color:T.textMid, marginBottom:12 }}>{message}</div>
    <button onClick={onRetry} style={{ background:T.orange, color:"#fff", border:"none", borderRadius:6, padding:"8px 18px", cursor:"pointer", fontWeight:700, fontSize:13, fontFamily:"inherit" }}>
      Retry
    </button>
  </div>
);

// ─── CAR CARD ─────────────────────────────────────────────────────────────────
const CarCard = ({ car, onClick }) => (
  <div onClick={onClick} style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, padding:16, cursor:"pointer", transition:"box-shadow 0.2s,transform 0.15s,border-color 0.2s", boxShadow:"0 1px 3px #0000000a" }}
    onMouseEnter={e=>{e.currentTarget.style.borderColor=T.orange;e.currentTarget.style.boxShadow=`0 6px 20px ${T.orange}18`;e.currentTarget.style.transform="translateY(-2px)";}}
    onMouseLeave={e=>{e.currentTarget.style.borderColor=T.border;e.currentTarget.style.boxShadow="0 1px 3px #0000000a";e.currentTarget.style.transform="translateY(0)";}}>
    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:10 }}>
      <div>
        <div style={{ fontSize:11, color:T.textSub, fontWeight:600 }}>{car.id}</div>
        <div style={{ fontSize:16, fontWeight:800, color:T.text, lineHeight:1.1 }}>{car.year} {car.make} {car.model}</div>
        <div style={{ fontSize:12, color:T.textSub, marginTop:2 }}>{car.city} · {Number(car.mileage).toLocaleString()} mi</div>
      </div>
      <Badge label={car.status} color={statColor(car.status)} bg={statBg(car.status)} />
    </div>
    <div style={{ display:"flex", gap:6, flexWrap:"wrap", marginBottom:12 }}>
      <Badge label={car.condition} color={condColor(car.condition)} bg={condBg(car.condition)} />
      {car.ownership && <Badge label="Ownership Track" color={T.purple} bg={T.purpleBg} />}
    </div>
    <PayoffBar car={car} compact />
    <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:6, marginTop:12 }}>
      {[["Startup",fmt(car.totalStartup),T.textMid],["Revenue",fmt(car.revenue),T.green],["Net",fmt(netProfit(car)),netProfit(car)>=0?T.green:T.red]].map(([l,v,c])=>(
        <div key={l} style={{ textAlign:"center", background:T.surface2, borderRadius:6, padding:"6px 4px" }}>
          <div style={{ fontSize:9, color:T.textSub, textTransform:"uppercase", letterSpacing:"0.08em", fontWeight:700 }}>{l}</div>
          <div style={{ fontSize:13, fontWeight:800, color:c, marginTop:1 }}>{v}</div>
        </div>
      ))}
    </div>
  </div>
);

// ─── DRIVER CARD ──────────────────────────────────────────────────────────────
const DriverCard = ({ driver, cars, onClick }) => {
  const matchedCar = (cars||[]).find(c=>c.id===driver.car);
  return (
  <div onClick={onClick} style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, padding:16, cursor:"pointer", transition:"box-shadow 0.2s,transform 0.15s,border-color 0.2s", boxShadow:"0 1px 3px #0000000a" }}
    onMouseEnter={e=>{e.currentTarget.style.borderColor=T.orange;e.currentTarget.style.boxShadow=`0 6px 20px ${T.orange}18`;e.currentTarget.style.transform="translateY(-2px)";}}
    onMouseLeave={e=>{e.currentTarget.style.borderColor=T.border;e.currentTarget.style.boxShadow="0 1px 3px #0000000a";e.currentTarget.style.transform="translateY(0)";}}>
    <div style={{ display:"flex", justifyContent:"space-between", marginBottom:10 }}>
      <div>
        <div style={{ fontSize:11, color:T.textSub, fontWeight:600 }}>{driver.id} · {driver.city}</div>
        <div style={{ fontSize:16, fontWeight:800, color:T.text, marginTop:1 }}>{driver.name}</div>
        <div style={{ fontSize:12, color:T.textSub }}>Car {driver.car} · {driver.weeksActive} wks</div>
        {driver.phone && (
          <a href={`tel:${driver.phone}`} onClick={e=>e.stopPropagation()} style={{ fontSize:12, color:T.orange, fontWeight:700, textDecoration:"none", display:"inline-block", marginTop:2 }}>
            📞 {fmtPhone(driver.phone)}
          </a>
        )}
      </div>
      <div style={{ display:"flex", flexDirection:"column", gap:4, alignItems:"flex-end" }}>
        {driver.status !== "Active" && <Badge label={driver.status} color={T.textSub} bg={T.surface2} />}
        <Badge label={driver.eligibility} color={eligColor(driver.eligibility)} bg={eligBg(driver.eligibility)} />
      </div>
    </div>
    <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:6 }}>
      {[["Paid",fmt(driver.paid),T.green],["Owed",fmt(driver.owed),driver.owed>0?T.red:T.textSub],["Trips",matchedCar?.totalTrips||"—",T.blue]].map(([l,v,c])=>(
        <div key={l} style={{ textAlign:"center", background:T.surface2, borderRadius:6, padding:"6px 4px" }}>
          <div style={{ fontSize:9, color:T.textSub, textTransform:"uppercase", letterSpacing:"0.08em", fontWeight:700 }}>{l}</div>
          <div style={{ fontSize:14, fontWeight:800, color:c, marginTop:1 }}>{v}</div>
        </div>
      ))}
    </div>
  </div>
  );
};

// ─── CAR DETAIL ───────────────────────────────────────────────────────────────
// Card grid showing predicted next-due mileage/date for each tracked service.
const MaintenancePanel = ({ car, repairs }) => {
  const preds = predictMaintenance(car, repairs);
  return (
    <div style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, padding:20, marginBottom:18, boxShadow:"0 1px 3px #0000000a" }}>
      <SectionLabel>Upcoming Maintenance (predicted from mileage)</SectionLabel>
      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(220px,1fr))", gap:12 }}>
        {preds.map(p => {
          const statusColor = !p.hasData ? T.textSub : p.overdue ? T.red : p.dueSoon ? T.gold : T.green;
          const statusBg    = !p.hasData ? T.surface2 : p.overdue ? T.redBg : p.dueSoon ? T.goldBg : T.greenBg;
          const statusLabel = !p.hasData ? "No data yet" : p.overdue ? "Overdue" : p.dueSoon ? "Due soon" : "On track";
          return (
            <div key={p.key} style={{ background:statusBg, border:`1px solid ${statusColor}33`, borderRadius:10, padding:16 }}>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:8 }}>
                <span style={{ fontSize:12, fontWeight:800, color:T.text }}>{p.label}</span>
                <span style={{ fontSize:9, fontWeight:800, color:statusColor, textTransform:"uppercase", letterSpacing:"0.06em" }}>{statusLabel}</span>
              </div>
              {p.hasData ? (
                <>
                  <div style={{ fontSize:18, fontWeight:800, color:statusColor, fontFamily:"'Barlow Condensed',sans-serif" }}>
                    {p.overdue ? `${Math.abs(p.milesRemaining).toLocaleString()} mi overdue` : `${p.milesRemaining.toLocaleString()} mi remaining`}
                  </div>
                  <div style={{ fontSize:11, color:T.textSub, marginTop:4 }}>
                    {p.estDate ? `Est. ${p.estDate.toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"})}` : "Not enough driving history yet to estimate a date"}
                  </div>
                  <div style={{ fontSize:10, color:T.textSub, marginTop:6, lineHeight:1.5 }}>
                    Last done {p.lastDate} at {p.lastMileage.toLocaleString()} mi
                    {p.lastVendor && p.lastVendor.vendorName && (
                      <div><VendorCell repair={p.lastVendor} inline /></div>
                    )}
                  </div>
                </>
              ) : (
                <div style={{ fontSize:11, color:T.textSub, lineHeight:1.5 }}>
                  Log a repair with mileage for a "{p.label}"-type entry to start predicting this one.
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

const CarDetail = ({ car, repairs, onBack, onSelectDriver }) => {
  const carRepairs = repairs.filter(r => r.carId === car.id);
  const r = roi(car);
  return (
    <div>
      <BackBtn label="Back" onClick={onBack} />
      <div style={{ display:"flex", alignItems:"flex-start", justifyContent:"space-between", flexWrap:"wrap", gap:16, marginBottom:24 }}>
        <div>
          <div style={{ fontSize:12, color:T.textSub, fontWeight:700, marginBottom:2 }}>{car.id}</div>
          <h2 style={{ color:T.text, fontFamily:"'Barlow Condensed',sans-serif", fontSize:34, fontWeight:800, margin:"0 0 8px", letterSpacing:"-0.01em" }}>{car.year} {car.make} {car.model}</h2>
          <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
            <Badge label={car.status}    color={statColor(car.status)}   bg={statBg(car.status)} />
            <Badge label={car.condition} color={condColor(car.condition)} bg={condBg(car.condition)} />
            <Badge label={car.city}      color={T.blue}                   bg={T.blueBg} />
            {car.ownership && <Badge label="Ownership Track" color={T.purple} bg={T.purpleBg} />}
          </div>
        </div>
        <div style={{ background:T.orangeL, border:`1px solid ${T.orange}33`, borderRadius:10, padding:"12px 20px", textAlign:"center" }}>
          <div style={{ fontSize:10, color:T.orange, textTransform:"uppercase", letterSpacing:"0.12em", fontWeight:800 }}>ROI</div>
          <div style={{ fontSize:32, fontWeight:900, color:r>=0?T.green:T.red, fontFamily:"'Barlow Condensed',sans-serif", lineHeight:1 }}>{r>=0?"+":""}{pct(r)}</div>
        </div>
      </div>

      <div style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, padding:20, marginBottom:18, boxShadow:"0 1px 3px #0000000a" }}>
        <SectionLabel>Financial Overview</SectionLabel>
        <div style={{ display:"flex", gap:24, flexWrap:"wrap", alignItems:"flex-start" }}>
          <div style={{ flex:"2 1 420px", minWidth:280 }}>
            <div style={{ display:"flex", gap:12, flexWrap:"wrap", marginBottom:18 }}>
              <KpiCard label="Total Startup"    value={fmt(car.totalStartup)}          accent={T.textMid} sub="purchase + prep" />
              <KpiCard label="Maint. & Repairs" value={fmt(car.maintenanceCost)}       accent={T.gold} />
              <KpiCard label="Insurance"        value={car.monthlyInsurance ? fmt(car.monthlyInsurance)+"/mo" : fmt(car.insuranceCost || 0)}    accent={T.blue} sub={car.monthlyInsurance ? "actual monthly premium" : "credits logged to this car"} />
              <KpiCard label="Total Investment" value={fmt(totalInv(car))}             accent={T.orange} />
              <KpiCard label="Earned Revenue"   value={fmt(car.revenue)}               accent={T.green} sub="cash + insurance credits" />
              <KpiCard label="Net Profit"       value={fmt(netProfit(car))} accent={netProfit(car)>=0?T.green:T.red} />
            </div>
            <PayoffBar car={car} compact={false} />
            <div style={{ marginTop:12, fontSize:11, color:T.textSub, lineHeight:1.6 }}>
              Insurance shown here is the amount credited on this car's payment rows. Insurance paid directly by FlexEarn
              (logged fleet-wide in 💸 Expenses → "Insurance Actual") is included in fleet Net Profit on the overview,
              but is not split per vehicle.
            </div>
          </div>
          <div style={{ flex:"1 1 220px", borderLeft:`1px solid ${T.border}`, paddingLeft:24 }}>
            <CarFinancialDonut car={car} repairs={repairs} />
          </div>
        </div>
      </div>

      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(280px,1fr))", gap:16, marginBottom:18 }}>
        <div style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, padding:18, boxShadow:"0 1px 3px #0000000a" }}>
          <SectionLabel>Vehicle Info</SectionLabel>
          {[["Mileage",Number(car.mileage).toLocaleString()+" mi"],["Last Service",car.lastService],["Condition",car.condition],["Status",car.status],["License Plate",car.licensePlate||"—"],["Registration Exp.",car.regExpiration||"—"],["VIN",car.vin||"—"],["Trips This Month",car.totalTrips||"—"]].map(([l,v])=>(
            <div key={l} style={{ display:"flex", justifyContent:"space-between", padding:"8px 0", borderBottom:`1px solid ${T.border}`, fontSize:13 }}>
              <span style={{ color:T.textSub, fontWeight:600 }}>{l}</span>
              <span style={{ color:T.text, fontWeight:700 }}>{v}</span>
            </div>
          ))}
        </div>
        <div style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, padding:18, boxShadow:"0 1px 3px #0000000a" }}>
          <SectionLabel>Notes</SectionLabel>
          <p style={{ fontSize:14, color:T.textMid, lineHeight:1.7, margin:0 }}>{car.notes || "No notes added."}</p>
        </div>
      </div>

      <MaintenancePanel car={car} repairs={repairs} />

      {car.driverObj && (
        <div onClick={()=>onSelectDriver && onSelectDriver(car.driverObj)} style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, padding:20, marginBottom:18, boxShadow:"0 1px 3px #0000000a", cursor: onSelectDriver ? "pointer" : "default" }}
          onMouseEnter={e=>{ if(onSelectDriver) e.currentTarget.style.borderColor=T.orange; }}
          onMouseLeave={e=>{ e.currentTarget.style.borderColor=T.border; }}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
            <SectionLabel>Current Driver</SectionLabel>
            {onSelectDriver && <span style={{ fontSize:11, color:T.orange, fontWeight:700 }}>View driver →</span>}
          </div>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", flexWrap:"wrap", gap:12, marginBottom:14 }}>
            <div>
              <div style={{ fontSize:18, fontWeight:800, color:T.text }}>{car.driverObj.name}</div>
              <div style={{ fontSize:13, color:T.textSub }}>{car.driverObj.id} · {car.driverObj.weeksActive} weeks</div>
            </div>
            <Badge label={car.driverObj.eligibility} color={eligColor(car.driverObj.eligibility)} bg={eligBg(car.driverObj.eligibility)} />
          </div>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(140px,1fr))", gap:10 }}>
            {[["Weekly Rate",fmt(car.driverObj.weeklyRate)],["Total Paid",fmt(car.driverObj.paid)],["Balance Due",fmt(car.driverObj.owed)],["Total Trips",car.totalTrips||"—"],["On-Time Pmts",Math.max(0,car.driverObj.paymentsMade-car.driverObj.missedPayments)],["Missed Pmts",car.driverObj.missedPayments]].map(([l,v])=>(
              <div key={l} style={{ background:T.surface2, borderRadius:8, padding:"10px 12px" }}>
                <div style={{ fontSize:10, color:T.textSub, textTransform:"uppercase", letterSpacing:"0.08em", fontWeight:700 }}>{l}</div>
                <div style={{ fontSize:16, fontWeight:800, color:T.text, marginTop:2 }}>{v}</div>
              </div>
            ))}
          </div>
        </div>
      )}

      <div style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, padding:20, boxShadow:"0 1px 3px #0000000a" }}>
        <SectionLabel>Repair & Maintenance History ({carRepairs.length} records · Total: {fmt(carRepairs.reduce((s,r)=>s+r.cost,0))})</SectionLabel>
        {carRepairs.length===0 ? <p style={{ color:T.textSub }}>No repair records found.</p> : (
          <div style={{ overflowX:"auto" }}>
          <table style={{ width:"100%", borderCollapse:"collapse", minWidth:560 }}>
            <thead><tr style={{ borderBottom:`2px solid ${T.border}` }}>
              {["Date","Description","Type","Vendor","Cost"].map(h=><th key={h} style={{ textAlign:"left", fontSize:10, color:T.textSub, textTransform:"uppercase", letterSpacing:"0.1em", padding:"6px 10px", fontWeight:700 }}>{h}</th>)}
            </tr></thead>
            <tbody>{[...carRepairs].sort((a,b)=>toDate(b.date)-toDate(a.date)).map((r,i)=>(
              <tr key={i} style={{ borderBottom:`1px solid ${T.border}` }}>
                <td style={{ padding:"11px 10px", fontSize:13, color:T.textMid, whiteSpace:"nowrap", verticalAlign:"top" }}>{r.date}</td>
                <td style={{ padding:"11px 10px", fontSize:13, color:T.text, verticalAlign:"top" }}>{r.desc}</td>
                <td style={{ padding:"11px 10px", fontSize:12, verticalAlign:"top" }}>{r.type && <Badge label={r.type} color={T.blue} bg={T.blueBg} />}</td>
                <td style={{ padding:"11px 10px", verticalAlign:"top" }}><VendorCell repair={r} /></td>
                <td style={{ padding:"11px 10px", fontSize:13, color:T.gold, fontWeight:800, verticalAlign:"top" }}>{fmt(r.cost)}</td>
              </tr>
            ))}</tbody>
          </table>
          </div>
        )}
      </div>
    </div>
  );
};

// ─── DRIVER DETAIL ────────────────────────────────────────────────────────────
const DriverDetail = ({ driver, cars, payments, onBack, onSelectCar }) => {
  const car = cars.find(c => c.id === driver.car);
  const driverPayments = payments.filter(p => p.driverId === driver.id).sort((a,b)=>toDate(b.date)-toDate(a.date));
  const [showAllPayments, setShowAllPayments] = useState(driverPayments.length <= 10);
  const checks = [
    ["Payments Made",          driver.paymentsMade >= 78,       `${driver.paymentsMade} / 78`],
    ["Missed Payments (12mo)", driver.missedPayments < 2,       driver.missedPayments === 0 ? "None" : `${driver.missedPayments} missed`],
    ["Amount Remaining",       driver.amountRemaining === 0,    driver.amountRemaining > 0 ? fmt(driver.amountRemaining) : "Paid in full"],
    ["Projected Ownership",    !!driver.projectedOwnershipDate, driver.projectedOwnershipDate || "—"],
  ];

  return (
    <div>
      <BackBtn label="Back" onClick={onBack} />
      <div style={{ marginBottom:24 }}>
        <div style={{ fontSize:12, color:T.textSub, fontWeight:700, marginBottom:2 }}>{driver.id} · {driver.city}</div>
        <h2 style={{ color:T.text, fontFamily:"'Barlow Condensed',sans-serif", fontSize:34, fontWeight:800, margin:"0 0 8px", letterSpacing:"-0.01em" }}>{driver.name}</h2>
        {driver.phone && (
          <a href={`tel:${driver.phone}`} style={{ display:"inline-block", fontSize:14, color:T.orange, fontWeight:700, textDecoration:"none", marginBottom:10 }}>
            📞 {fmtPhone(driver.phone)}
          </a>
        )}
        <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
          {driver.status !== "Active" && <Badge label={driver.status} color={T.textSub} bg={T.surface2} />}
          <Badge label={driver.eligibility} color={eligColor(driver.eligibility)} bg={eligBg(driver.eligibility)} />
          <Badge label={driver.city} color={T.blue} bg={T.blueBg} />
          {driver.onTrack && <Badge label="Ownership Track" color={T.purple} bg={T.purpleBg} />}
        </div>
      </div>

      <div style={{ display:"flex", gap:12, flexWrap:"wrap", marginBottom:20 }}>
        <KpiCard label="Amount Paid"       value={fmt(driver.paid)}              accent={T.green} />
        <KpiCard label="Remaining"         value={fmt(driver.amountRemaining)}   accent={driver.amountRemaining>0?T.orange:T.green} />
        <KpiCard label="Target Amount"     value={fmt(driver.targetAmount)}      accent={T.textMid} />
        <KpiCard label="Weekly Rate"       value={fmt(driver.weeklyRate)}        accent={T.orange} />
        <KpiCard label="Payments Made"     value={`${driver.paymentsMade} / 78`} accent={T.blue} />
        <KpiCard label="Weeks Active"      value={driver.weeksActive}            accent={T.textMid} />
        <KpiCard label="Progress"          value={`${driver.progressPct}%`}     accent={driver.progressPct>=100?T.green:T.purple} />
        <KpiCard label="Projected Title"   value={driver.projectedOwnershipDate || "—"} accent={T.gold} />
      </div>

      {driver.onTrack && (
        <div style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, padding:20, marginBottom:18, boxShadow:"0 1px 3px #0000000a" }}>
          <SectionLabel>Ownership Progress</SectionLabel>
          <div style={{ display:"flex", justifyContent:"space-between", marginBottom:6 }}>
            <span style={{ fontSize:13, color:T.textMid, fontWeight:600 }}>Payments: {driver.paymentsMade} of 78</span>
            <span style={{ fontSize:13, fontWeight:800, color:driver.progressPct>=100?T.green:T.orange }}>{driver.progressPct}%</span>
          </div>
          <div style={{ background:T.border, borderRadius:6, height:12, overflow:"hidden", marginBottom:8 }}>
            <div style={{ width:`${Math.min(driver.progressPct,100)}%`, background:driver.progressPct>=100?T.green:`linear-gradient(90deg,#f4600c,#d44e08)`, height:"100%", borderRadius:6, transition:"width 0.4s" }} />
          </div>
          <div style={{ display:"flex", justifyContent:"space-between", fontSize:12, color:T.textSub }}>
            <span>{fmt(driver.paid)} paid</span>
            <span>{fmt(driver.amountRemaining)} remaining</span>
            <span>Target: {fmt(driver.targetAmount)}</span>
          </div>
          {driver.missedPayments >= 1 && (
            <div style={{ marginTop:12, padding:"10px 14px", background:driver.missedPayments>=2?T.redBg:T.goldBg, border:`1px solid ${driver.missedPayments>=2?T.red:T.gold}33`, borderRadius:8, fontSize:13, color:driver.missedPayments>=2?T.red:T.gold, fontWeight:700 }}>
              {driver.missedPayments>=2 ? "⚠ Ineligible — 2+ missed payments in 12 months" : "⚠ At Risk — 1 missed payment this 12-month period"}
            </div>
          )}
        </div>
      )}

      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(280px,1fr))", gap:16, marginBottom:18 }}>
        <div style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, padding:20, boxShadow:"0 1px 3px #0000000a" }}>
          <CollapsibleSection title={`Payment History (${driverPayments.length} records)`}>
          <div style={{ display:"flex", gap:20, marginBottom:16 }}>
            {[["On-Time",Math.max(0,driver.paymentsMade-driver.missedPayments),T.green],["Missed",driver.missedPayments,driver.missedPayments>0?T.red:T.textSub],["Progress",driver.progressPct+"%",driver.progressPct>=100?T.green:T.orange]].map(([l,v,c])=>(
              <div key={l}>
                <div style={{ fontSize:10, color:T.textSub, textTransform:"uppercase", letterSpacing:"0.1em", fontWeight:700 }}>{l}</div>
                <div style={{ fontSize:26, fontWeight:900, color:c, fontFamily:"'Barlow Condensed',sans-serif", lineHeight:1 }}>{v}</div>
              </div>
            ))}
          </div>
          {driverPayments.length > 0 ? (<>
            <table style={{ width:"100%", borderCollapse:"collapse" }}>
              <thead><tr style={{ borderBottom:`2px solid ${T.border}` }}>
                {["Period","Amount","Ins. Credit","Method","Status","Receipt"].map(h=><th key={h} style={{ textAlign:"left", fontSize:10, color:T.textSub, textTransform:"uppercase", letterSpacing:"0.1em", padding:"5px 8px", fontWeight:700 }}>{h}</th>)}
              </tr></thead>
              <tbody>{(showAllPayments ? driverPayments : driverPayments.slice(0,10)).map((p,i)=>(
                <tr key={i} style={{ borderBottom:`1px solid ${T.border}` }}>
                  <td style={{ padding:"9px 8px", fontSize:13, color:T.textMid }}>{p.weekStart}{p.weekEnd?` – ${p.weekEnd}`:""}</td>
                  <td style={{ padding:"9px 8px", fontSize:13, fontWeight:700, color:T.text }}>{fmt(p.amount)}</td>
                  <td style={{ padding:"9px 8px", fontSize:13, color:p.insuranceCredit>0?T.blue:T.textSub }}>{p.insuranceCredit>0?fmt(p.insuranceCredit):"—"}</td>
                  <td style={{ padding:"9px 8px", fontSize:12, color:T.textSub }}>{p.method}</td>
                  <td style={{ padding:"9px 8px" }}><Badge label={p.status} color={p.status==="Paid"?T.green:p.status==="Late"?T.red:T.gold} bg={p.status==="Paid"?T.greenBg:p.status==="Late"?T.redBg:T.goldBg} /></td>
                  <td style={{ padding:"9px 8px" }}>{p.receiptLink ? <a href={p.receiptLink} target="_blank" rel="noreferrer" style={{ fontSize:12, color:T.orange, fontWeight:700, textDecoration:"none" }}>View ↗</a> : <span style={{ fontSize:12, color:T.textSub }}>—</span>}</td>
                </tr>
              ))}</tbody>
            </table>
            {driverPayments.length > 10 && (
              <button onClick={()=>setShowAllPayments(s=>!s)} style={{ background:"none", border:`1px solid ${T.border2}`, color:T.orange, borderRadius:6, padding:"6px 14px", cursor:"pointer", fontSize:12, fontWeight:700, fontFamily:"inherit", marginTop:12 }}>
                {showAllPayments ? "Show recent 10" : `Show all ${driverPayments.length} payments`}
              </button>
            )}
          </>) : <p style={{ color:T.textSub, fontSize:13 }}>No payment records yet.</p>}
          </CollapsibleSection>
        </div>

        <div style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, padding:20, boxShadow:"0 1px 3px #0000000a" }}>
          <SectionLabel>Ownership Eligibility</SectionLabel>
          <div style={{ marginBottom:16 }}>
            <Badge label={driver.eligibility} color={eligColor(driver.eligibility)} bg={eligBg(driver.eligibility)} />
          </div>
          {checks.map(([label,met,note])=>(
            <div key={label} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"10px 0", borderBottom:`1px solid ${T.border}` }}>
              <div style={{ fontSize:13, color:T.textMid, fontWeight:500 }}>{label}</div>
              <div style={{ display:"flex", gap:10, alignItems:"center" }}>
                <span style={{ fontSize:12, color:T.textSub }}>{note}</span>
                <span style={{ fontSize:16, fontWeight:800, color:met?T.green:T.red }}>{met?"✓":"✗"}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {car && (
        <div onClick={()=>onSelectCar && onSelectCar(car)} style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, padding:20, boxShadow:"0 1px 3px #0000000a", cursor: onSelectCar ? "pointer" : "default" }}
          onMouseEnter={e=>{ if(onSelectCar) e.currentTarget.style.borderColor=T.orange; }}
          onMouseLeave={e=>{ e.currentTarget.style.borderColor=T.border; }}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
            <SectionLabel>Assigned Vehicle</SectionLabel>
            {onSelectCar && <span style={{ fontSize:11, color:T.orange, fontWeight:700 }}>View vehicle →</span>}
          </div>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", flexWrap:"wrap", gap:12, marginBottom:14 }}>
            <div>
              <div style={{ fontSize:18, fontWeight:800, color:T.text }}>{car.year} {car.make} {car.model}</div>
              <div style={{ fontSize:13, color:T.textSub }}>{car.id} · {Number(car.mileage).toLocaleString()} mi · Last service {car.lastService}</div>
            </div>
            <div style={{ display:"flex", gap:8 }}>
              <Badge label={car.condition} color={condColor(car.condition)} bg={condBg(car.condition)} />
              <Badge label={car.status}    color={statColor(car.status)}    bg={statBg(car.status)} />
            </div>
          </div>
          <PayoffBar car={car} compact={false} />
          {car.notes && <p style={{ marginTop:14, fontSize:13, color:T.textMid, background:T.surface2, borderRadius:8, padding:"10px 14px", lineHeight:1.7 }}>{car.notes}</p>}
        </div>
      )}
    </div>
  );
};

// ─── CITY PANEL ───────────────────────────────────────────────────────────────
const CityPanel = ({ city, cars, drivers, onBack, onSelectCar, onSelectDriver }) => {
  const cityCars     = cars.filter(c => c.city === city);
  const cityDrivers  = drivers.filter(d => d.city === city);
  const totalRev     = cityCars.reduce((s,c)=>s+c.revenue,0);
  const totalMaint   = cityCars.reduce((s,c)=>s+c.maintenanceCost,0);
  // Fixed: previously summed insurance across the ENTIRE fleet inside a city view.
  const totalIns     = cityCars.reduce((s,c)=>s+(c.insuranceAccrued||0),0);
  const totalStartup = cityCars.reduce((s,c)=>s+c.totalStartup,0);
  const cityNet      = totalRev - totalMaint - totalIns;
  return (
    <div>
      <BackBtn label="All Cities" onClick={onBack} />
      <h2 style={{ color:T.text, fontFamily:"'Barlow Condensed',sans-serif", fontSize:30, fontWeight:800, margin:"0 0 20px" }}>{city}</h2>
      <StatStrip items={[
        ["Vehicles", cityCars.length, T.orange],
        ["Drivers", cityDrivers.length, T.blue],
        ["Fleet Startup", fmt(totalStartup), T.textMid],
        ["Earned Revenue", fmt(totalRev), T.green],
        ["Net Profit", fmt(cityNet), cityNet>=0?T.green:T.red, "after repairs + insurance"],
        ["Ownership Track", cityDrivers.filter(d=>d.onTrack).length, T.purple],
      ]} />
      <div style={{ marginBottom:28 }}>
        <SectionLabel>Fleet</SectionLabel>
        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(260px,1fr))", gap:12 }}>
          {cityCars.map(car=><CarCard key={car.id} car={car} onClick={()=>onSelectCar(car)} />)}
        </div>
      </div>
      <SectionLabel>Drivers</SectionLabel>
      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(260px,1fr))", gap:12 }}>
        {cityDrivers.map(d=><DriverCard key={d.id} driver={d} cars={cityCars} onClick={()=>onSelectDriver(d)} />)}
      </div>
    </div>
  );
};

// ─── LOG PAYMENT MODAL ──────────────────────────────────────────────────────
// Mirrors the Apps Script sidebar exactly (same fields, same preview math)
// but posts to the Web App bridge instead of running inside Sheets.
const LogPaymentModal = ({ onClose, onLogged }) => {
  const [drivers, setDrivers]         = useState([]);
  const [loadErr, setLoadErr]         = useState(null);
  const [driverId, setDriverId]       = useState("");
  const [weekStart, setWeekStart]     = useState(new Date().toISOString().slice(0,10));
  const [numDays, setNumDays]         = useState("");
  const [method, setMethod]           = useState("Cash");
  const [amountActual, setAmountActual] = useState("");
  const [feeType, setFeeType]         = useState("");   // "" = no fee
  const [feeAmount, setFeeAmount]     = useState("");
  const [submitting, setSubmitting]   = useState(false);
  const [result, setResult]           = useState(null); // { ok, message }

  useEffect(() => {
    if (DASHBOARD_ENDPOINT.startsWith("PASTE_")) {
      setLoadErr("Payment logging isn't connected yet — ask your developer to finish the Apps Script Web App setup.");
      return;
    }
    fetch(`${DASHBOARD_ENDPOINT}?key=${encodeURIComponent(DASHBOARD_KEY)}`)
      .then(r => r.json())
      .then(data => {
        if (!data.ok) { setLoadErr(data.error || "Failed to load drivers."); return; }
        setDrivers(data.drivers || []);
      })
      .catch(() => setLoadErr("Couldn't reach the payment service. Check your connection and try again."));
  }, []);

  const driver = drivers.find(d => d.id === driverId);
  const isDaily = driver?.planType === "Daily Plan";

  const expectedAmount = useMemo(() => {
    if (!driver) return 0;
    return isDaily ? driver.rate * (parseInt(numDays) || 1) : driver.rate;
  }, [driver, isDaily, numDays]);

  useEffect(() => { setAmountActual(expectedAmount ? expectedAmount.toFixed(2) : ""); }, [expectedAmount]);

  const submit = async () => {
    if (!driver) return;
    setSubmitting(true);
    setResult(null);
    try {
      const res = await fetch(DASHBOARD_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "text/plain;charset=utf-8" }, // avoids CORS preflight against Apps Script
        body: JSON.stringify({
          key: DASHBOARD_KEY, driverId, weekStart,
          numDays: isDaily ? numDays : "", method, amount: amountActual,
          feeType: feeType || "", feeAmount: feeType ? feeAmount : ""
        })
      });
      const data = await res.json();
      if (!data.ok) { setResult({ ok:false, message: data.error || "Something went wrong." }); return; }
      if (data.receiptSent) {
        setResult({ ok:true, message: `Logged & receipt sent to ${driver.name}.` });
        onLogged?.();
        setDriverId(""); setNumDays(""); setMethod("Cash");
        setFeeType(""); setFeeAmount("");
        setWeekStart(new Date().toISOString().slice(0,10));
      } else {
        setResult({ ok:false, message: `Payment logged, but receipt did NOT send — ${data.receiptReason}` });
        onLogged?.();
      }
    } catch (err) {
      setResult({ ok:false, message: "Network error — payment may not have been logged. Check the sheet before retrying." });
    } finally {
      setSubmitting(false);
    }
  };

  const field = { display:"block", fontSize:11, fontWeight:700, color:T.textMid, textTransform:"uppercase", letterSpacing:"0.5px", margin:"14px 0 4px" };
  const input = { width:"100%", padding:8, fontSize:14, border:`1px solid ${T.border}`, borderRadius:6, boxSizing:"border-box", fontFamily:"inherit" };

  return (
    <div onClick={onClose} style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.45)", zIndex:1000, display:"flex", alignItems:"center", justifyContent:"center", padding:20 }}>
      <div onClick={e => e.stopPropagation()} style={{ background:"#fff", borderRadius:12, padding:24, width:420, maxWidth:"100%", maxHeight:"90vh", overflowY:"auto" }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:4 }}>
          <div style={{ fontSize:17, fontWeight:900, color:T.text }}>Log Payment</div>
          <button onClick={onClose} style={{ background:"none", border:"none", fontSize:20, color:T.textSub, cursor:"pointer" }}>×</button>
        </div>

        {loadErr && <div style={{ marginTop:12, padding:10, background:T.redBg, color:T.red, borderRadius:6, fontSize:12.5 }}>{loadErr}</div>}

        {!loadErr && (
          <>
            <label style={field}>Driver</label>
            <select style={input} value={driverId} onChange={e => setDriverId(e.target.value)}>
              <option value="">Select a driver...</option>
              {drivers.map(d => <option key={d.id} value={d.id}>{d.id} - {d.name}</option>)}
            </select>
            {driver && <div style={{ fontSize:12, color:T.textSub, marginTop:4 }}>
              {isDaily ? `Daily Plan · $${driver.rate}/day` : `${driver.planType} · $${driver.rate}/week`}
            </div>}

            <label style={field}>Week Start Date</label>
            <input type="date" style={input} value={weekStart} onChange={e => setWeekStart(e.target.value)} />

            {isDaily && (
              <>
                <label style={field}># of Days</label>
                <select style={input} value={numDays} onChange={e => setNumDays(e.target.value)}>
                  <option value="">1 (single day)</option>
                  {[2,3,4,5,6,7].map(n => <option key={n} value={n}>{n}{n===7?" (full week)":""}</option>)}
                </select>
              </>
            )}

            <label style={field}>Payment Method</label>
            <select style={input} value={method} onChange={e => setMethod(e.target.value)}>
              {["Cash","Zelle","CashApp","ACH","Other"].map(m => <option key={m}>{m}</option>)}
            </select>

            <label style={field}>Add a Fee? (optional)</label>
            <select style={input} value={feeType} onChange={e => { setFeeType(e.target.value); if(!e.target.value) setFeeAmount(""); if(e.target.value==="Late Fee" && !feeAmount) setFeeAmount("25"); }}>
              <option value="">No fee</option>
              {["Late Fee","BG Check Fee","NSF Fee","Tolls","Other"].map(f => <option key={f} value={f}>{f}</option>)}
            </select>
            {feeType && (
              <>
                <label style={field}>Fee Amount ($)</label>
                <input type="number" step="0.01" style={input} value={feeAmount} onChange={e => setFeeAmount(e.target.value)} placeholder="25.00" />
                <div style={{ fontSize:11.5, color:T.textSub, marginTop:4 }}>
                  Shows as its own line item on the receipt. Keep the lease amount below unchanged — the receipt total adds them together.
                </div>
              </>
            )}

            <label style={field}>Expected Amount</label>
            <div style={{ fontSize:20, fontWeight:900, color:T.orange, marginTop:4 }}>{fmt(expectedAmount)}</div>

            <label style={field}>Lease Amount Received (edit if different — short payment, proration, etc. Fees go in the fee field above, not here.)</label>
            <input type="number" step="0.01" style={input} value={amountActual} onChange={e => setAmountActual(e.target.value)} />

            <button
              onClick={submit}
              disabled={!driver || submitting || (feeType && !(Number(feeAmount) > 0))}
              style={{ width:"100%", marginTop:20, padding:12, background:(!driver||submitting||(feeType&&!(Number(feeAmount)>0)))?T.border2:T.orange, color:"#fff", border:"none", borderRadius:6, fontSize:14, fontWeight:700, cursor:(!driver||submitting||(feeType&&!(Number(feeAmount)>0)))?"not-allowed":"pointer" }}>
              {submitting ? "Logging..." : "Log Payment & Send Receipt"}
            </button>

            {result && (
              <div style={{ marginTop:12, padding:10, borderRadius:6, fontSize:12.5, textAlign:"center", background:result.ok?T.greenBg:T.redBg, color:result.ok?T.green:T.red, fontWeight:700 }}>
                {result.ok ? "👍 " : "⚠ "}{result.message}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

// ─── MAIN APP ─────────────────────────────────────────────────────────────────
export default function App() {
  const [authed, setAuthed] = useState(!!sessionStorage.getItem("fe_auth"));
  if (!authed) return <LoginScreen onLogin={() => setAuthed(true)} />;
  return <Dashboard />;
}

function Dashboard() {
  const isMobile = useIsMobile();
  const [rawCars,     setRawCars]     = useState([]);
  const [drivers,     setDrivers]     = useState([]);
  const [repairs,     setRepairs]     = useState([]);
  const [payments,    setPayments]    = useState([]);
  const [expenses,    setExpenses]    = useState([]);
  const [loading,     setLoading]     = useState(true);
  const [error,       setError]       = useState(null);
  const [lastUpdated, setLastUpdated] = useState(null);
  const [showLogPayment, setShowLogPayment] = useState(false);

  const [view,           setView]           = useState("overview");
  const [selectedCity,   setSelectedCity]   = useState(null);
  const [selectedCar,    setSelectedCar]    = useState(null);
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [tab,            setTab]            = useState("fleet");
  const [fleetSearch,    setFleetSearch]    = useState("");
  const [driverSearch,   setDriverSearch]   = useState("");
  const [fleetMode,      setFleetMode]      = useState(null);   // null = auto
  const [driverMode,     setDriverMode]     = useState(null);
  const [expandedMonth,  setExpandedMonth]  = useState(null);   // Monthly Actual vs Budget drill-down

  const loadData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const [carsRaw, driversRaw, repairsRaw, paymentsRaw, expensesRaw] = await Promise.all([
        fetchSheet(TABS.cars),
        fetchSheet(TABS.drivers),
        fetchSheet(TABS.repairs),
        fetchSheet(TABS.payments),
        fetchSheet(TABS.expenses),
      ]);
      setRawCars(normalizeCars(carsRaw));
      setDrivers(normalizeDrivers(driversRaw));
      setRepairs(normalizeRepairs(repairsRaw));
      setPayments(normalizePayments(paymentsRaw));
      setExpenses(normalizeExpenses(expensesRaw));
      setLastUpdated(new Date());
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { loadData(); }, [loadData]);

  // ── PER-CAR ENRICHMENT ──────────────────────────────────────────────────────
  // Revenue = Earned Revenue (cash + insurance credits), attached by Car ID so
  // it stays with the vehicle even if the driver changes. Insurance cost per
  // car = the credits FlexEarn absorbed on that car's payments.
  const cars = rawCars.map(car => {
    const driver   = drivers.find(d => d.id === car.driver);
    const carPays  = payments.filter(p => p.carId === car.id && p.status === "Paid");
    const revenue        = carPays.reduce((s, p) => s + p.earnedRevenue, 0);
    const cashCollected  = carPays.reduce((s, p) => s + p.amount, 0);
    const insuranceCost  = carPays.reduce((s, p) => s + p.insuranceCredit, 0);
    // ACCRUED insurance: the car's true cost to date — actual monthly premium
    // (from the Cars tab) x 12 / 52 per week, for every week the assigned
    // driver has been active. This is the number the P&L subtracts, so profit
    // no longer depends on premiums being manually logged as expenses.
    const insuranceAccrued = driver && driver.weeksActive
      ? driver.weeksActive * ((car.monthlyInsurance * 12) / 52) : 0;
    const maintenanceCost = calcMaintenance(car.id, repairs);
    return { ...car, revenue, cashCollected, insuranceCost, insuranceAccrued, maintenanceCost, driverObj: driver || null };
  });

  const CITIES = [...new Set(cars.map(c => c.city).filter(Boolean))].sort();

  // Drivers who've left the program are kept in the sheet (for payment
  // history) but marked Status = "Inactive"/"Archived" instead of deleted —
  // this is what keeps counts, lists, and search limited to real active
  // drivers without losing historical records. `drivers` still holds
  // everyone, for the rare lookup that needs a former driver's info.
  const activeDrivers = drivers.filter(d => !["Inactive","Archived"].includes(d.status));

  // ── OIL-CHANGE REPAIRS, GROUPED BY MONTH (for the Financials tab) ──────────
  // Pulls every repair tagged "oil" out of the generic repairs pile and groups
  // it by the same month label the 💸 Expenses tab uses, so it can be shown
  // alongside (not instead of) the manually-entered "Oil Changes Actual" cell.
  const oilRepairsByMonth = useMemo(() => {
    const map = {};
    repairs.filter(isOilRepair).forEach(r => {
      const m = monthLabel(r.date);
      if (!m) return;
      (map[m] ||= []).push(r);
    });
    return map;
  }, [repairs]);
  const expensesWithOil = useMemo(() => expenses.map(e => {
    const oilRepairs = oilRepairsByMonth[e.month] || [];
    const oilFromRepairs = oilRepairs.reduce((s,r)=>s+r.cost,0);
    return { ...e, oilRepairs, oilFromRepairs, oilActualCombined: e.oilActual + oilFromRepairs };
  }), [expenses, oilRepairsByMonth]);

  // ── FLEET P&L (the source of truth for the hero) ────────────────────────────
  const totalRevenue     = cars.reduce((s,c)=>s+c.revenue,0);
  const totalMaint       = cars.reduce((s,c)=>s+c.maintenanceCost,0);
  // ACCRUAL BASIS: insurance = each car's actual premium x weeks active
  // (computed per car above). Insurance credits and Expenses "Insurance
  // Actual" are deliberately NOT added on top — those are the cash-side
  // records of the same premiums, and adding them would double-count.
  const totalInsurance   = cars.reduce((s,c)=>s+(c.insuranceAccrued||0),0);
  // Oil / Tracking / Ads actuals from 💸 Expenses. Maintenance Actual is
  // excluded — repairs are already counted from the 🔧 Repairs tab.
  const otherOpex        = expenses.reduce((s,e)=>s+e.oilActual+e.trackActual+e.adsActual,0);
  const fleetNet         = totalRevenue - totalMaint - totalInsurance - otherOpex;
  const pnl = { revenue: totalRevenue, repairs: totalMaint, insurance: totalInsurance, otherOpex, net: fleetNet };

  const totalStartup  = cars.reduce((s,c)=>s+c.totalStartup,0);
  const totalInvested = totalStartup + totalMaint;
  const overallROI    = totalInvested > 0 ? ((totalRevenue - totalInvested) / totalInvested * 100).toFixed(1) : 0;
  const onTrackCount  = activeDrivers.filter(d=>d.onTrack).length;
  const eligibleCount = activeDrivers.filter(d=>d.eligibility==="Ownership Eligible").length;
  const activeCount   = cars.filter(c=>c.status==="Active").length;

  // ── ALERTS ──────────────────────────────────────────────────────────────────
  const alerts = [];
  const now = new Date();
  const currentMonthLabel = now.toLocaleDateString("en-US",{month:"short",year:"numeric"});
  // 1. No insurance logged this month → profit may be overstated.
  const curExp = expenses.find(e => e.month.trim().toLowerCase() === currentMonthLabel.toLowerCase());
  const curMonthCredits = payments
    .filter(p => { const d = toDate(p.date); return d.getMonth()===now.getMonth() && d.getFullYear()===now.getFullYear(); })
    .reduce((s,p)=>s+p.insuranceCredit,0);
  if ((!curExp || curExp.insuranceActual === 0) && curMonthCredits === 0 && activeCount > 0) {
    alerts.push({ level:"gold", title:"No insurance logged this month",
      detail:`~${fmt(activeCount * INSURANCE_CAP_MONTHLY)} expected (${activeCount} active cars × $${INSURANCE_CAP_MONTHLY}/mo cap). Net Profit above may be overstated until it's entered.` });
  }
  // 2. Registration expiring / expired.
  cars.forEach(c => {
    if (!c.regExpiration) return;
    const exp = toDate(c.regExpiration);
    if (exp.getTime() === 0) return;
    const days = Math.ceil((exp - now) / 86400000);
    if (days < 0)        alerts.push({ level:"red",  title:`Registration expired — ${c.id}`, detail:`${c.year} ${c.make} ${c.model} · expired ${c.regExpiration}`, onClick:()=>{setSelectedCar(c);setView("car");} });
    else if (days <= 45) alerts.push({ level:"gold", title:`Registration expiring — ${c.id}`, detail:`${c.year} ${c.make} ${c.model} · ${days} days left (${c.regExpiration})`, onClick:()=>{setSelectedCar(c);setView("car");} });
  });
  // 3. Drivers with missed payments.
  activeDrivers.filter(d=>d.missedPayments>0).forEach(d => {
    alerts.push({ level: d.missedPayments>=2 ? "red" : "gold", title:`${d.missedPayments} missed payment${d.missedPayments>1?"s":""} — ${d.name}`,
      detail:`${d.id} · ${d.city} · ${d.missedPayments>=2 ? "now Ineligible" : "At Risk"}`, onClick:()=>{setSelectedDriver(d);setView("driver");} });
  });
  // 4. Active cars with no assigned driver = idle capital.
  cars.filter(c=>c.status==="Active" && !c.driver).forEach(c => {
    alerts.push({ level:"gold", title:`Active car unassigned — ${c.id}`, detail:`${c.year} ${c.make} ${c.model} · ${c.city} · earning $0/week`, onClick:()=>{setSelectedCar(c);setView("car");} });
  });
  // 5. Predicted maintenance overdue or due soon (needs "Mileage at Service"
  //    logged on at least one matching repair per car — see predictMaintenance).
  cars.forEach(c => {
    predictMaintenance(c, repairs).filter(p => p.hasData && (p.overdue || p.dueSoon)).forEach(p => {
      alerts.push({
        level: p.overdue ? "red" : "gold",
        title: `${p.label} ${p.overdue ? "overdue" : "due soon"} — ${c.id}`,
        detail: (p.overdue
          ? `${Math.abs(p.milesRemaining).toLocaleString()} mi past due · ${c.year} ${c.make} ${c.model}`
          : `${p.milesRemaining.toLocaleString()} mi remaining · ${c.year} ${c.make} ${c.model}`)
          // Last shop used, so the alert says who to call without a click-through.
          + (p.lastVendor && p.lastVendor.vendorName ? ` · last done at ${p.lastVendor.vendorName}${p.lastVendor.vendorLocation ? ` (${p.lastVendor.vendorLocation.replace(/,?\s*TX.*$/i,"")})` : ""}` : ""),
        onClick: () => { setSelectedCar(c); setView("car"); },
      });
    });
  });

  // 6. Maintenance eating an outsized share of a car's revenue.
  const maintFlagCars = cars.filter(c => {
    if (c.revenue > 0) return (c.maintenanceCost / c.revenue) > 0.25;
    return c.maintenanceCost > 1500; // no revenue yet but already expensive
  });
  maintFlagCars.forEach(c => {
    const ratio = c.revenue > 0 ? c.maintenanceCost / c.revenue : null;
    alerts.push({
      level: (ratio !== null && ratio > 0.4) ? "red" : "gold",
      title: `High maintenance cost — ${c.id}`,
      detail: ratio !== null
        ? `${c.year} ${c.make} ${c.model} · ${pct(ratio*100)} of its revenue has gone to repairs`
        : `${c.year} ${c.make} ${c.model} · ${fmt(c.maintenanceCost)} in repairs against $0 revenue so far`,
      onClick: () => { setSelectedCar(c); setView("car"); },
    });
  });

  const topCars     = [...cars].sort((a,b)=>netProfit(b)-netProfit(a)).slice(0,3);
  const lowestMaint = [...cars].sort((a,b)=>a.maintenanceCost-b.maintenanceCost).slice(0,3);

  // ── FLEET INSIGHTS — best/worst performer, with a takeaway ─────────────────
  const revenueCars = cars.filter(c => c.revenue > 0);
  const bestCar  = revenueCars.length ? [...revenueCars].sort((a,b)=>roi(b)-roi(a))[0] : null;
  const worstCar = revenueCars.length ? [...revenueCars].sort((a,b)=>(a.maintenanceCost/a.revenue)-(b.maintenanceCost/b.revenue)).slice(-1)[0] : null;
  const fleetAvgMaintRatio = revenueCars.length ? revenueCars.reduce((s,c)=>s+c.maintenanceCost/c.revenue,0)/revenueCars.length : 0;

  const cityStats = CITIES.map(city => {
    const cc = cars.filter(c=>c.city===city);
    const dd = activeDrivers.filter(d=>d.city===city);
    return { city, cars:cc.length, drivers:dd.length,
      revenue:  cc.reduce((s,c)=>s+c.revenue,0),
      maint:    cc.reduce((s,c)=>s+c.maintenanceCost,0),
      insurance:cc.reduce((s,c)=>s+(c.insuranceCost||0),0),
      startup:  cc.reduce((s,c)=>s+c.totalStartup,0),
    };
  });

  // ── MONTHLY ACTUAL VS. BUDGET — CAR-LEVEL DRILL-DOWN ────────────────────────
  // The Budget/Actual/Variance columns come straight from the 💸 Expenses tab,
  // which is a fleet-wide, manually-reconciled row — it isn't split per car in
  // the sheet. What IS split per car in the source data is revenue (Payments)
  // and repair cost, incl. oil (Repairs), so that's what the drill-down shows:
  // every car with paid revenue or a logged repair in that calendar month.
  const carBreakdownForMonth = (monthStr) => {
    const inMonth = dateStr => monthLabel(dateStr) === monthStr;
    const byCar = {};
    const touch = id => (byCar[id] ||= { revenue:0, oil:0, otherRepairs:0 });
    payments.filter(p => p.status === "Paid" && p.carId && inMonth(p.weekStart))
      .forEach(p => { touch(p.carId).revenue += p.earnedRevenue; });
    repairs.filter(r => r.carId && inMonth(r.date)).forEach(r => {
      const bucket = touch(r.carId);
      if (isOilRepair(r)) bucket.oil += r.cost; else bucket.otherRepairs += r.cost;
    });
    return Object.entries(byCar).map(([carId, v]) => {
      const carObj = cars.find(c => c.id === carId);
      return { carId, car: carObj, ...v, net: v.revenue - v.oil - v.otherRepairs };
    }).sort((a,b) => b.net - a.net);
  };

  // ── FILTERED LISTS ──────────────────────────────────────────────────────────
  const q = fleetSearch.trim().toLowerCase();
  const filteredCars = q === "" ? cars : cars.filter(c =>
    [c.id, c.year, c.make, c.model, c.city, c.vin, c.licensePlate, c.status, c.driverObj?.name].join(" ").toLowerCase().includes(q));
  const dq = driverSearch.trim().toLowerCase();
  // Default list is Active drivers only (keeps counts/cards accurate); a
  // search query searches the full roster, including Inactive/Archived
  // drivers, so a former driver's history is still reachable when needed.
  const filteredDrivers = dq === "" ? activeDrivers : drivers.filter(d =>
    [d.id, d.name, d.city, d.car, d.eligibility, d.phone].join(" ").toLowerCase().includes(dq));

  // Auto view mode: cards while the fleet is small, table once it grows.
  const fleetView  = fleetMode  || (isMobile ? "cards" : (cars.length    > 12 ? "table" : "cards"));
  const driverView = driverMode || (isMobile ? "cards" : (activeDrivers.length > 12 ? "table" : "cards"));

  const goBack = () => {
    if(view==="car"||view==="driver") selectedCity ? setView("city") : setView("overview");
    else if(view==="city") setView("overview");
  };

  return (
    <div style={{ minHeight:"100vh", background:T.bg, color:T.text, fontFamily:"'DM Sans','Segoe UI',sans-serif" }}>
      <link href="https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@600;700;800;900&family=DM+Sans:wght@400;500;600;700;800&display=swap" rel="stylesheet" />

      {/* HEADER */}
      <div style={{ background:"#ffffff", borderBottom:`2px solid ${T.orange}`, boxShadow:"0 2px 8px #0000000d", position:"sticky", top:0, zIndex:100 }}>
        <div style={{ maxWidth:1320, margin:"0 auto", padding: isMobile ? "0 14px" : "0 28px", display:"flex", alignItems:"center", justifyContent:"space-between", height:62 }}>
          <div onClick={() => { setView("overview"); setSelectedCar(null); setSelectedDriver(null); setSelectedCity(null); setTab("fleet"); window.scrollTo({top:0,behavior:"smooth"}); }}
            title="Back to overview"
            style={{ display:"flex", alignItems:"center", gap:isMobile?10:14, cursor:"pointer", minWidth:0 }}>
            <div style={{ background:`linear-gradient(135deg,${T.orange},${T.orangeD})`, borderRadius:8, width:36, height:36, flexShrink:0, display:"flex", alignItems:"center", justifyContent:"center", fontSize:18, color:"#fff", fontWeight:900, fontFamily:"'Barlow Condensed',sans-serif" }}>F</div>
            <div style={{ minWidth:0 }}>
              <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900, fontSize:isMobile?17:20, color:T.text, lineHeight:1, letterSpacing:"0.01em", whiteSpace:"nowrap" }}>
                FLEX<span style={{ color:T.orange }}>EARN</span> FLEET
              </div>
              {!isMobile && <div style={{ fontSize:10, color:T.textSub, letterSpacing:"0.1em", textTransform:"uppercase", fontWeight:700 }}>Operations Dashboard</div>}
            </div>
          </div>
          <div style={{ display:"flex", alignItems:"center", gap:isMobile?10:20, flexShrink:0 }}>
            <button onClick={() => setShowLogPayment(true)} style={{ background:T.orange, border:"none", color:"#fff", borderRadius:6, padding: isMobile ? "7px 10px" : "7px 14px", cursor:"pointer", fontSize:12, fontFamily:"inherit", fontWeight:700, whiteSpace:"nowrap" }}>
              {isMobile ? "+ Log" : "+ Log Payment"}
            </button>
            {lastUpdated && !loading && (
              <button onClick={loadData} title="Refresh" style={{ background:"none", border:`1px solid ${T.border2}`, color:T.textSub, borderRadius:6, padding: isMobile ? "5px 8px" : "5px 12px", cursor:"pointer", fontSize:11, fontFamily:"inherit", fontWeight:600 }}>
                ↻{!isMobile && " Refresh"}
              </button>
            )}
            {!isMobile && <a href="https://flexearnfleet.com" target="_blank" rel="noreferrer" style={{ fontSize:12, color:T.orange, fontWeight:700, textDecoration:"none" }}>flexearnfleet.com ↗</a>}
            {!isMobile && (
              <div style={{ fontSize:11, color:T.textSub, fontWeight:600 }}>
                {new Date().toLocaleDateString("en-US",{weekday:"short",month:"short",day:"numeric",year:"numeric"})}
              </div>
            )}
          </div>
        </div>
      </div>

      <div style={{ maxWidth:1320, margin:"0 auto", padding: isMobile ? "16px 14px 40px" : "28px 28px 60px" }}>
        {loading && <Spinner />}
        {!loading && error && <ErrorBanner message={error} onRetry={loadData} />}
        {!loading && !error && (
          <>
            {/* ── OVERVIEW ── */}
            {view==="overview" && (<>
              {/* 1. The number that owns the page */}
              <PnLHero pnl={pnl} onSegmentClick={() => {
                setTab("financials");
                document.getElementById("fleet-tab-section")?.scrollIntoView({ behavior:"smooth", block:"start" });
              }} />

              {/* 2. Quiet fleet stats — one strip, fixed height forever */}
              <StatStrip items={[
                ["Fleet", cars.length, T.orange, `${activeCount} active`],
                ["Drivers", activeDrivers.length, T.blue],
                ["Fleet Startup", fmt(totalStartup), T.textMid, "purchase + prep"],
                ["Overall ROI", (Number(overallROI)>=0?"+":"")+overallROI+"%", Number(overallROI)>=0?T.green:T.red, "vs. total invested"],
                ["Ownership Track", onTrackCount, T.purple, `${eligibleCount} eligible now`],
              ]} />

              {/* 3. What needs attention today */}
              <AlertsStrip alerts={alerts} />

              {/* 3b. Best/worst performer, with a takeaway */}
              <FleetInsights bestCar={bestCar} worstCar={worstCar} fleetAvgMaintRatio={fleetAvgMaintRatio}
                onSelectCar={c=>{setSelectedCar(c);setView("car");}} />

              <div style={{ marginBottom:32 }}>
                <SectionLabel>Cities</SectionLabel>
                <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(270px,1fr))", gap:14 }}>
                  {cityStats.map(cs=>{
                    const cityNet = cs.revenue - cs.maint - cs.insurance;
                    return (
                    <div key={cs.city} onClick={()=>{setSelectedCity(cs.city);setView("city");}}
                      style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, padding:20, cursor:"pointer", transition:"box-shadow 0.2s,transform 0.15s,border-color 0.2s", boxShadow:"0 1px 3px #0000000a" }}
                      onMouseEnter={e=>{e.currentTarget.style.borderColor=T.orange;e.currentTarget.style.boxShadow=`0 6px 20px ${T.orange}18`;e.currentTarget.style.transform="translateY(-3px)";}}
                      onMouseLeave={e=>{e.currentTarget.style.borderColor=T.border;e.currentTarget.style.boxShadow="0 1px 3px #0000000a";e.currentTarget.style.transform="translateY(0)";}}>
                      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:14 }}>
                        <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontSize:24, fontWeight:800, color:T.text }}>{cs.city}</div>
                        <span style={{ color:T.orange, fontWeight:800 }}>→</span>
                      </div>
                      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(280px,1fr))", gap:10, marginBottom:12 }}>
                        {[["Vehicles",cs.cars,T.orange],["Drivers",cs.drivers,T.blue],["Revenue",fmt(cs.revenue),T.green],["Net Profit",fmt(cityNet),cityNet>=0?T.green:T.red]].map(([l,v,c])=>(
                          <div key={l}>
                            <div style={{ fontSize:9, color:T.textSub, textTransform:"uppercase", letterSpacing:"0.1em", fontWeight:700 }}>{l}</div>
                            <div style={{ fontSize:17, fontWeight:800, color:c }}>{v}</div>
                          </div>
                        ))}
                      </div>
                      <div style={{ fontSize:9, color:T.textSub, textTransform:"uppercase", letterSpacing:"0.1em", fontWeight:700, marginBottom:4 }}>Fleet Cost Recovery</div>
                      <div style={{ background:T.border, borderRadius:4, height:5, overflow:"hidden" }}>
                        <div style={{ width:pct(Math.min(100,cs.startup>0?Math.round(cs.revenue/cs.startup*100):0)), background:`linear-gradient(90deg,${T.orange},${T.orangeD})`, height:"100%", borderRadius:4 }} />
                      </div>
                      <div style={{ fontSize:11, color:T.textSub, marginTop:4 }}>
                        {cs.startup>0?Math.min(100,Math.round(cs.revenue/cs.startup*100)):0}% of {fmt(cs.startup)} recovered
                      </div>
                    </div>
                  );})}
                </div>
              </div>

              {/* Sticky tab bar — stays reachable while scrolled down, so switching
                  Fleet / Drivers / Financials never requires scrolling to the top. */}
              <div id="fleet-tab-section" style={{ display:"flex", alignItems:"center", justifyContent:"space-between", flexWrap:"wrap", gap:8, borderBottom:`2px solid ${T.border}`, marginBottom:20, position:"sticky", top:62, zIndex:90, background:T.bg, paddingTop:6 }}>
                <div style={{ display:"flex" }}>
                  {[["fleet",`Fleet (${cars.length})`],["drivers",`Drivers (${activeDrivers.length})`],["financials","Financials"]].map(([key,label])=>(
                    <button key={key} onClick={()=>setTab(key)} style={{ background:"none", border:"none", borderBottom:tab===key?`3px solid ${T.orange}`:"3px solid transparent", color:tab===key?T.orange:T.textSub, padding:"10px 22px", cursor:"pointer", fontSize:13, fontWeight:800, textTransform:"uppercase", letterSpacing:"0.08em", fontFamily:"inherit", marginBottom:"-2px", transition:"color 0.2s" }}>
                      {label}
                    </button>
                  ))}
                </div>
                {tab==="financials" && expenses.length > 0 && (
                  <div style={{ display:"flex", gap:6, flexWrap:"wrap", paddingBottom:8 }}>
                    {[["fin-weekly-model","Weekly Model"],["fin-weekly-actuals","Weekly Actuals"],["fin-monthly-budget","Monthly Budget"],["fin-expense-breakdown","Breakdown"]].map(([id,label])=>(
                      <button key={id} onClick={()=>document.getElementById(id)?.scrollIntoView({behavior:"smooth",block:"start"})}
                        style={{ background:T.surface, border:`1px solid ${T.border2}`, color:T.textMid, borderRadius:20, padding:"5px 12px", cursor:"pointer", fontSize:11, fontWeight:700, fontFamily:"inherit" }}
                        onMouseEnter={e=>{e.currentTarget.style.borderColor=T.orange;e.currentTarget.style.color=T.orange;}}
                        onMouseLeave={e=>{e.currentTarget.style.borderColor=T.border2;e.currentTarget.style.color=T.textMid;}}>
                        {label} ↓
                      </button>
                    ))}
                  </div>
                )}
              </div>

              {tab==="fleet" && (<>
                <div style={{ display:"flex", gap:24, flexWrap:"wrap", marginBottom:24 }}>
                  {[["Top Performing Cars",topCars,(c)=>fmt(netProfit(c)),T.green],["Lowest Maintenance",lowestMaint,(c)=>fmt(c.maintenanceCost),T.gold]].map(([title,list,val,color])=>(
                    <div key={title} style={{ flex:1, minWidth:260, background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, padding:18, boxShadow:"0 1px 3px #0000000a" }}>
                      <SectionLabel>{title}</SectionLabel>
                      {list.map(c=>(
                        <div key={c.id} onClick={()=>{setSelectedCar(c);setView("car");}} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"10px 0", borderBottom:`1px solid ${T.border}`, cursor:"pointer" }}
                          onMouseEnter={e=>e.currentTarget.style.opacity="0.7"} onMouseLeave={e=>e.currentTarget.style.opacity="1"}>
                          <div><div style={{ fontSize:14, fontWeight:700, color:T.text }}>{c.year} {c.make} {c.model}</div><div style={{ fontSize:11, color:T.textSub }}>{c.city} · {c.id}</div></div>
                          <div style={{ color, fontWeight:800 }}>{val(c)}</div>
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
                <ListControls search={fleetSearch} setSearch={setFleetSearch} mode={fleetView} setMode={setFleetMode}
                  placeholder="Search fleet — ID, make, model, city, VIN, plate, driver…" count={filteredCars.length} />
                {/* Data-window caption: these table figures are cumulative (all-time),
                    so show the actual date span the numbers cover. Insurance is the
                    one monthly figure in the table, so call that out too. */}
                {(() => {
                  const paidDates = payments.filter(p => p.status === "Paid" && p.weekStart)
                    .map(p => new Date(p.weekStart)).filter(d => !isNaN(d));
                  if (!paidDates.length) return null;
                  const minD = new Date(Math.min(...paidDates));
                  const fmtD = d => d.toLocaleDateString("en-US", { month:"short", day:"numeric", year:"numeric" });
                  return (
                    <div style={{ fontSize:11, color:T.textSub, margin:"2px 0 10px", fontWeight:600 }}>
                      Revenue, Maint. &amp; Repairs, Net &amp; Payoff are cumulative — all payments logged {fmtD(minD)} to today. Each car accrues from its own first payment. Insurance is a monthly premium, not a cumulative total.
                    </div>
                  );
                })()}
                {fleetView === "table"
                  ? <FleetTable cars={filteredCars} onSelect={car=>{setSelectedCar(car);setView("car");}} />
                  : <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(260px,1fr))", gap:12 }}>
                      {filteredCars.map(car=><CarCard key={car.id} car={car} onClick={()=>{setSelectedCar(car);setView("car");}} />)}
                    </div>}
              </>)}

              {tab==="drivers" && (<>
                <ListControls search={driverSearch} setSearch={setDriverSearch} mode={driverView} setMode={setDriverMode}
                  placeholder="Search drivers — ID, name, city, car, eligibility…" count={filteredDrivers.length} />
                {driverView === "table"
                  ? <DriversTable drivers={filteredDrivers} onSelect={d=>{setSelectedDriver(d);setView("driver");}} />
                  : <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(260px,1fr))", gap:12 }}>
                      {filteredDrivers.map(d=><DriverCard key={d.id} driver={d} cars={cars} onClick={()=>{setSelectedDriver(d);setView("driver");}} />)}
                    </div>}
              </>)}

              {tab==="financials" && (
                <div>
                  {expenses.length === 0 ? (
                    <div style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, padding:32, textAlign:"center", color:T.textSub }}>
                      No expense data yet — fill in the 💸 Expenses tab in your Google Sheet to see financials here.
                    </div>
                  ) : (<>
                    {/* Weekly budget model — clearly labeled as the MODEL, not actuals.
                        Insurance is billed monthly, so it's SHOWN as a monthly figure
                        here — but it still counts toward Total Expenses / Net for
                        Acquisition below at its true weekly-equivalent rate, since it's
                        a real recurring cost that eats into what's available to spend
                        on the next vehicle, premium timing aside. */}
                    {(() => {
                      const active = activeCount;
                      const weeklyRev   = cars.filter(c=>c.status==="Active").reduce((s,c)=>{
                        const d = drivers.find(dr=>dr.id===c.driver);
                        return s + (d ? d.weeklyRate : 0);
                      },0);
                      const weeklyIns   = active * (INSURANCE_CAP_MONTHLY / 4);
                      const monthlyIns  = active * INSURANCE_CAP_MONTHLY;
                      const weeklyOil   = active * (55/4.3);
                      const weeklyTrack = active * (32/4.3);
                      const weeklyMaint = weeklyRev * 0.06;
                      const weeklyAds   = active * 5;
                      const totalExp = weeklyIns + weeklyOil + weeklyTrack + weeklyMaint + weeklyAds;
                      const netAcq = weeklyRev - totalExp;
                      return (
                        <div style={{ marginBottom:28 }}>
                          <CollapsibleSection id="fin-weekly-model" title={`Weekly Run-Rate Model (Budget — based on ${active} active cars)`}>
                            <div style={{ display:"flex", gap:12, flexWrap:"wrap", marginBottom:8 }}>
                              <KpiCard label="Scheduled Revenue"  value={fmt(weeklyRev)}   accent={T.green} sub="sum of weekly rates" />
                              <KpiCard label="Insurance"          value={fmt(monthlyIns)+"/mo"} accent={T.gold} sub={`$${INSURANCE_CAP_MONTHLY}/mo cap × ${active} cars`} />
                              <KpiCard label="Oil Changes"        value={fmt(Math.round(weeklyOil))} accent={T.gold} />
                              <KpiCard label="Tracking/GPS"       value={fmt(Math.round(weeklyTrack))} accent={T.gold} />
                              <KpiCard label="Maintenance (6%)"   value={fmt(Math.round(weeklyMaint))} accent={T.gold} />
                              <KpiCard label="Ads & Admin"        value={fmt(weeklyAds)}   accent={T.gold} />
                              <KpiCard label="Total Expenses"     value={fmt(Math.round(totalExp))} accent={T.orange} />
                              <KpiCard label="Net for Acquisition" value={fmt(Math.round(netAcq))} accent={netAcq>0?T.green:T.red} />
                            </div>
                            <div style={{ fontSize:11, color:T.textSub, fontWeight:600 }}>
                              Insurance is shown as its true monthly premium above, but is still counted at its weekly-equivalent rate inside Total Expenses and Net for Acquisition, since it's a real recurring cost even though it isn't billed weekly.
                            </div>
                          </CollapsibleSection>
                        </div>
                      );
                    })()}

                    {/* ── WEEKLY BREAKDOWN BY CITY (ACTUALS) ─────────────────────
                        Groups every Paid payment into its calendar week (Mon-Sun,
                        matching the Monday due-date cycle) and splits by city.
                        Revenue and Repairs genuinely land week to week, so they
                        stay here. Insurance does NOT — it's a monthly premium,
                        not a weekly cost, so it's intentionally excluded from
                        this table and shown only in the monthly views (Monthly
                        Actual vs. Budget, and each car's detail page) where the
                        real billing cadence matches the number shown. */}
                    {(() => {
                      const mondayOf = d => {
                        const dt = new Date(d); if (isNaN(dt)) return null;
                        const day = dt.getDay();
                        dt.setDate(dt.getDate() - ((day + 6) % 7));
                        dt.setHours(0,0,0,0);
                        return dt;
                      };
                      const carCity = id => (cars.find(c => c.id === id) || {}).city || "Unknown";

                      const weekSet = new Set();
                      const paid = payments.filter(p => p.status === "Paid" && p.weekStart);
                      paid.forEach(p => { const m = mondayOf(p.weekStart); if (m) weekSet.add(+m); });
                      repairs.forEach(r => { const m = mondayOf(r.date); if (m) weekSet.add(+m); });
                      const weeks = [...weekSet].sort((a,b)=>a-b).map(t=>new Date(t));
                      if (!weeks.length) return null;

                      const cityList = [...new Set(cars.map(c=>c.city).filter(Boolean))].sort();
                      const fmtD = d => d.toLocaleDateString("en-US",{month:"short",day:"numeric"});

                      const rows = weeks.map(wk => {
                        const byCity = {};
                        cityList.forEach(city => {
                          const rev = paid.filter(p => {
                            const m = mondayOf(p.weekStart);
                            return m && +m === +wk && carCity(p.carId) === city;
                          }).reduce((s,p)=>s+p.earnedRevenue,0);
                          const rep = repairs.filter(r => {
                            const m = mondayOf(r.date);
                            return m && +m === +wk && carCity(r.carId) === city;
                          }).reduce((s,r)=>s+r.cost,0);
                          byCity[city] = { rev, rep, net: rev - rep };
                        });
                        return { wk, byCity };
                      });

                      const recentRows = rows.slice(-8);

                      return (
                        <div style={{ marginBottom:28 }}>
                          <CollapsibleSection id="fin-weekly-actuals" title="Weekly Breakdown by City (Actuals)" defaultOpen={rows.length <= 8}>
                            <WeeklyCityTable rows={rows} recentRows={recentRows} cityList={cityList} fmtD={fmtD} />
                            <div style={{ fontSize:11, color:T.textSub, marginTop:8, fontWeight:600 }}>
                              Insurance is billed monthly, not weekly, so it's tracked in Monthly Actual vs. Budget below (and on each car's detail page) instead of here.
                            </div>
                          </CollapsibleSection>
                        </div>
                      );
                    })()}

                    {/* Actual vs Budget Table */}
                    <div id="fin-monthly-budget" style={{ scrollMarginTop:132 }}>
                    <SectionLabel>Monthly Actual vs. Budget — click a row for the car-level breakdown</SectionLabel>
                    <div style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, overflow:"hidden", boxShadow:"0 1px 3px #0000000a" }}>
                      <table style={{ width:"100%", borderCollapse:"collapse" }}>
                        <thead>
                          <tr style={{ background:DARK_STR }}>
                            {["","Month","Cars","Revenue","Budget","Actual","Variance","Net"].map(h=>(
                              <th key={h} style={{ padding:"12px 14px", fontSize:10, fontWeight:700, color:"#ffffff", textTransform:"uppercase", letterSpacing:"0.1em", textAlign:"left", background:"#1A1612" }}>{h}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {expensesWithOil.map((exp,i)=>{
                            const variance = exp.variance;
                            const bg = i%2===0 ? T.surface : T.surface2;
                            const isOpen = expandedMonth === exp.month;
                            const rowsForMonth = isOpen ? carBreakdownForMonth(exp.month) : [];
                            return (
                              <Fragment key={i}>
                              <tr onClick={()=>setExpandedMonth(isOpen ? null : exp.month)}
                                style={{ borderBottom:`1px solid ${T.border}`, background: isOpen ? T.orangeL : bg, cursor:"pointer" }}
                                onMouseEnter={e=>{ if(!isOpen) e.currentTarget.style.background=T.surface2; }}
                                onMouseLeave={e=>{ if(!isOpen) e.currentTarget.style.background=bg; }}>
                                <td style={{ padding:"12px 10px", textAlign:"center" }}>
                                  <span style={{ display:"inline-flex", alignItems:"center", justifyContent:"center", width:22, height:22, borderRadius:"50%", background: isOpen ? T.orange : T.orangeL, border:`1px solid ${T.orange}55`, color: isOpen ? "#fff" : T.orange, fontSize:11, fontWeight:800 }}>
                                    {isOpen ? "▾" : "▸"}
                                  </span>
                                </td>
                                <td style={{ padding:"12px 14px", fontSize:13, fontWeight:700, color:T.text }}>{exp.month}</td>
                                <td style={{ padding:"12px 14px", fontSize:13, color:T.textMid }}>{exp.activeCars}</td>
                                <td style={{ padding:"12px 14px", fontSize:13, color:T.green, fontWeight:700 }}>{exp.grossRevenue>0?fmt(exp.grossRevenue):"—"}</td>
                                <td style={{ padding:"12px 14px", fontSize:13, color:T.textMid }}>{fmt(exp.totalBudget)}</td>
                                <td style={{ padding:"12px 14px", fontSize:13, color:T.text, fontWeight:700 }}>{exp.totalActual>0?fmt(exp.totalActual):"—"}</td>
                                <td style={{ padding:"12px 14px", fontSize:13, fontWeight:800, color:variance>=0?T.green:T.red }}>
                                  {exp.totalActual>0?(variance>=0?"+":"")+fmt(variance):"—"}
                                </td>
                                <td style={{ padding:"12px 14px", fontSize:13, fontWeight:800, color:exp.netAfterExpenses>0?T.green:T.red }}>
                                  {exp.netAfterExpenses>0?fmt(exp.netAfterExpenses):"—"}
                                </td>
                              </tr>
                              {isOpen && (
                                <tr>
                                  <td colSpan={8} style={{ padding:0, background:T.surface2, borderBottom:`2px solid ${T.orange}33` }}>
                                    <div style={{ padding:"16px 20px" }}>
                                      <div style={{ fontSize:11, color:T.textSub, marginBottom:12, lineHeight:1.6 }}>
                                        Budget, Actual &amp; Variance above are the fleet-wide figures reconciled on the 💸 Expenses tab — that sheet
                                        row isn't split per car. What follows is car-level Revenue and Repairs (from 💰 Payments and 🔧 Repairs) for
                                        every car with activity in <strong>{exp.month}</strong>{exp.oilFromRepairs>0 ? <> — {fmt(exp.oilFromRepairs)} of the repairs below is tagged as oil changes.</> : "."}
                                      </div>
                                      {rowsForMonth.length === 0 ? (
                                        <div style={{ fontSize:13, color:T.textSub, padding:"8px 0" }}>No payments or repairs logged for any car in {exp.month}.</div>
                                      ) : (
                                        <table style={{ width:"100%", borderCollapse:"collapse" }}>
                                          <thead><tr style={{ borderBottom:`1px solid ${T.border2}` }}>
                                            {["Car","Revenue","Oil","Other Repairs","Net"].map(h=>(
                                              <th key={h} style={{ textAlign: h==="Car"?"left":"right", fontSize:10, color:T.textSub, textTransform:"uppercase", letterSpacing:"0.08em", padding:"6px 10px", fontWeight:700 }}>{h}</th>
                                            ))}
                                          </tr></thead>
                                          <tbody>
                                            {rowsForMonth.map(row=>(
                                              <tr key={row.carId} onClick={e=>{ e.stopPropagation(); if(row.car){ setSelectedCar(row.car); setSelectedCity(null); setView("car"); } }}
                                                style={{ borderBottom:`1px solid ${T.border}`, cursor: row.car ? "pointer" : "default" }}
                                                onMouseEnter={e=>{ if(row.car) e.currentTarget.style.background=T.orangeL; }}
                                                onMouseLeave={e=>{ e.currentTarget.style.background="transparent"; }}>
                                                <td style={{ padding:"9px 10px", fontSize:13, fontWeight:700, color: row.car ? T.orange : T.text }}>
                                                  {row.car ? `${row.car.year} ${row.car.make} ${row.car.model}` : row.carId} <span style={{ color:T.textSub, fontWeight:600 }}>· {row.carId}</span>
                                                </td>
                                                <td style={{ padding:"9px 10px", fontSize:13, textAlign:"right", color:T.green, fontWeight:700 }}>{row.revenue>0?fmt(row.revenue):"—"}</td>
                                                <td style={{ padding:"9px 10px", fontSize:13, textAlign:"right", color:T.gold, fontWeight:700 }}>{row.oil>0?fmt(row.oil):"—"}</td>
                                                <td style={{ padding:"9px 10px", fontSize:13, textAlign:"right", color:T.textMid, fontWeight:700 }}>{row.otherRepairs>0?fmt(row.otherRepairs):"—"}</td>
                                                <td style={{ padding:"9px 10px", fontSize:13, textAlign:"right", fontWeight:800, color: row.net>=0 ? T.green : T.red }}>{fmt(row.net)}</td>
                                              </tr>
                                            ))}
                                          </tbody>
                                        </table>
                                      )}
                                    </div>
                                  </td>
                                </tr>
                              )}
                              </Fragment>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                    </div>

                    {/* Expense Breakdown per Category - latest month */}
                    {expensesWithOil[0] && expensesWithOil[0].totalActual > 0 && (
                      <div id="fin-expense-breakdown" style={{ marginTop:24, scrollMarginTop:132 }}>
                        <SectionLabel>Latest Month — Expense Breakdown ({expensesWithOil[0].month})</SectionLabel>
                        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(220px,1fr))", gap:12 }}>
                          {[
                            ["Insurance",    expensesWithOil[0].insuranceBudget, expensesWithOil[0].insuranceActual, null],
                            ["Oil Changes",  expensesWithOil[0].oilBudget,       expensesWithOil[0].oilActualCombined, expensesWithOil[0].oilFromRepairs],
                            ["Tracking/GPS", expensesWithOil[0].trackBudget,     expensesWithOil[0].trackActual, null],
                            ["Maintenance",  expensesWithOil[0].maintBudget,     expensesWithOil[0].maintActual, null],
                            ["Ads & Admin",  expensesWithOil[0].adsBudget,       expensesWithOil[0].adsActual, null],
                          ].map(([label, budget, actual, fromRepairs])=>{
                            const v = budget - actual;
                            const pctUsed = budget > 0 ? Math.min(100, Math.round(actual/budget*100)) : 0;
                            return (
                              <div key={label} style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:10, padding:16, boxShadow:"0 1px 3px #0000000a" }}>
                                <div style={{ fontSize:11, fontWeight:700, color:T.textSub, textTransform:"uppercase", letterSpacing:"0.08em", marginBottom:8 }}>{label}</div>
                                <div style={{ display:"flex", justifyContent:"space-between", marginBottom:6 }}>
                                  <span style={{ fontSize:11, color:T.textSub }}>Budget: {fmt(budget)}</span>
                                  <span style={{ fontSize:11, fontWeight:700, color:actual>0?T.text:T.textSub }}>Actual: {actual>0?fmt(actual):"—"}</span>
                                </div>
                                <div style={{ background:T.border, borderRadius:4, height:6, overflow:"hidden", marginBottom:6 }}>
                                  <div style={{ width:`${pctUsed}%`, background:pctUsed>100?T.red:pctUsed>80?T.gold:T.green, height:"100%", borderRadius:4 }} />
                                </div>
                                <div style={{ fontSize:11, fontWeight:700, color:v>=0?T.green:T.red, textAlign:"right" }}>
                                  {actual>0?(v>=0?"✓ Under budget by "+fmt(v):"⚠ Over by "+fmt(Math.abs(v))):"Not entered yet"}
                                </div>
                                {fromRepairs > 0 && (
                                  <div style={{ fontSize:10, color:T.gold, textAlign:"right", marginTop:4, fontWeight:600 }}>
                                    incl. {fmt(fromRepairs)} auto-pulled from 🔧 Repairs tagged "oil"
                                  </div>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    )}
                  </>)}
                </div>
              )}
            </>)}

            {view!=="overview" && (
              <div style={{ display:"flex", alignItems:"center", gap:6, marginBottom:16, flexWrap:"wrap", fontSize:12 }}>
                <button onClick={()=>{setView("overview");setSelectedCar(null);setSelectedDriver(null);setSelectedCity(null);}}
                  style={{ background:"none", border:"none", color:T.orange, fontWeight:700, cursor:"pointer", padding:0, fontFamily:"inherit", fontSize:12 }}>Overview</button>
                {selectedCity && (<>
                  <span style={{ color:T.textSub }}>/</span>
                  <button onClick={()=>{setView("city");setSelectedCar(null);setSelectedDriver(null);}}
                    style={{ background:"none", border:"none", color: view==="city" ? T.textMid : T.orange, fontWeight:700, cursor: view==="city" ? "default" : "pointer", padding:0, fontFamily:"inherit", fontSize:12 }}>{selectedCity}</button>
                </>)}
                {view==="car" && selectedCar && (<>
                  <span style={{ color:T.textSub }}>/</span>
                  <span style={{ color:T.textMid, fontWeight:700 }}>{selectedCar.year} {selectedCar.make} {selectedCar.model}</span>
                </>)}
                {view==="driver" && selectedDriver && (<>
                  <span style={{ color:T.textSub }}>/</span>
                  <span style={{ color:T.textMid, fontWeight:700 }}>{selectedDriver.name}</span>
                </>)}
              </div>
            )}

            {view==="city" && selectedCity && (
              <CityPanel city={selectedCity} cars={cars} drivers={activeDrivers}
                onBack={()=>setView("overview")}
                onSelectCar={car=>{setSelectedCar(car);setView("car");}}
                onSelectDriver={d=>{setSelectedDriver(d);setView("driver");}} />
            )}

            {view==="car" && selectedCar && (
              <CarDetail car={cars.find(c=>c.id===selectedCar.id)||selectedCar} repairs={repairs} onBack={goBack}
                onSelectDriver={d=>{setSelectedDriver(d);setView("driver");}} />
            )}

            {view==="driver" && selectedDriver && (
              <DriverDetail driver={drivers.find(d=>d.id===selectedDriver.id)||selectedDriver} cars={cars} payments={payments} onBack={goBack}
                onSelectCar={c=>{setSelectedCar(c);setView("car");}} />
            )}
          </>
        )}
      </div>

      {showLogPayment && (
        <LogPaymentModal
          onClose={() => setShowLogPayment(false)}
          onLogged={loadData}
        />
      )}
    </div>
  );
}
